/**
 * Generated from CharlesDickensStoryLayout.fla
 */
export function CharlesDickensStoryLayout(this: ICharlesDickensStoryLayout) {
	const scene1Start = this.scene1Start;
	CharlesDickensStoryLayout_scene1Start.call(this.scene1Start);
	scene1Start.x = 0;
	scene1Start.y = 0;
	if (scene1Start.onLayout) scene1Start.onLayout();
	const scene2Imagination = this.scene2Imagination;
	CharlesDickensStoryLayout_scene2Imagination.call(this.scene2Imagination);
	scene2Imagination.x = 0;
	scene2Imagination.y = 0;
	if (scene2Imagination.onLayout) scene2Imagination.onLayout();
	const scene3Location = this.scene3Location;
	CharlesDickensStoryLayout_scene3Location.call(this.scene3Location);
	scene3Location.x = 0;
	scene3Location.y = 0;
	if (scene3Location.onLayout) scene3Location.onLayout();
	const scene4Chair = this.scene4Chair;
	CharlesDickensStoryLayout_scene4Chair.call(this.scene4Chair);
	scene4Chair.x = 0;
	scene4Chair.y = 0;
	if (scene4Chair.onLayout) scene4Chair.onLayout();
	const scene5Belt = this.scene5Belt;
	CharlesDickensStoryLayout_scene5Belt.call(this.scene5Belt);
	scene5Belt.x = 0;
	scene5Belt.y = 0;
	if (scene5Belt.onLayout) scene5Belt.onLayout();
	const scene6End = this.scene6End;
	CharlesDickensStoryLayout_scene6End.call(this.scene6End);
	scene6End.x = 0;
	scene6End.y = 0;
	if (scene6End.onLayout) scene6End.onLayout();
	return this;
}
export function CharlesDickensStoryLayout_scene1Start(this: ICharlesDickensStoryLayout_scene1Start) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"couch"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_slotBradCouch.call(items[0] as ICharlesDickensStoryLayout_slotBradCouch);
		(items[0] as ICharlesDickensStoryLayout_slotBradCouch).animation = "";
		(items[0] as ICharlesDickensStoryLayout_slotBradCouch).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_slotBradCouch).option = "couch";
		items[0].x = 1015.15;
		items[0].y = 1102.25;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"blanket"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_slotBradBlanket.call(items[1] as ICharlesDickensStoryLayout_slotBradBlanket);
		(items[1] as ICharlesDickensStoryLayout_slotBradBlanket).animation = "";
		(items[1] as ICharlesDickensStoryLayout_slotBradBlanket).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_slotBradBlanket).option = "blanket";
		items[1].x = 1010.6;
		items[1].y = 1097;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"bed"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_slotBradBed.call(items[2] as ICharlesDickensStoryLayout_slotBradBed);
		(items[2] as ICharlesDickensStoryLayout_slotBradBed).animation = "";
		(items[2] as ICharlesDickensStoryLayout_slotBradBed).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_slotBradBed).option = "bed";
		items[2].x = 1020.85;
		items[2].y = 1115.5;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"beanbag"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_slotBradBeanBag.call(items[3] as ICharlesDickensStoryLayout_slotBradBeanBag);
		(items[3] as ICharlesDickensStoryLayout_slotBradBeanBag).animation = "";
		(items[3] as ICharlesDickensStoryLayout_slotBradBeanBag).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_slotBradBeanBag).option = "beanbag";
		items[3].x = 1025.25;
		items[3].y = 1117.5;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_slotBradCouch(this: ICharlesDickensStoryLayout_slotBradCouch) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch id=couch","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicCouch.call(items[0] as ICharlesDickensStoryLayout_dicCouch);
		(items[0] as ICharlesDickensStoryLayout_dicCouch).animation = "squishStretch id=couch";
		(items[0] as ICharlesDickensStoryLayout_dicCouch).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicCouch).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 1086.00;
		items[0].height = 552.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"follow couch","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicBLaying.call(items[1] as ICharlesDickensStoryLayout_dicBLaying);
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).animation = "follow couch";
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).option = "";
		items[1].x = -87.3;
		items[1].y = -604.7;
		items[1].width = 614.00;
		items[1].height = 450.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicCouch(this: ICharlesDickensStoryLayout_dicCouch) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-couch.png", 0.500, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicBLaying(this: ICharlesDickensStoryLayout_dicBLaying) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-laying.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_slotBradBlanket(this: ICharlesDickensStoryLayout_slotBradBlanket) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch id=blanket","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBlanket.call(items[0] as ICharlesDickensStoryLayout_dicBlanket);
		(items[0] as ICharlesDickensStoryLayout_dicBlanket).animation = "squishStretch id=blanket";
		(items[0] as ICharlesDickensStoryLayout_dicBlanket).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBlanket).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 970.00;
		items[0].height = 296.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"follow blanket","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicBLaying.call(items[1] as ICharlesDickensStoryLayout_dicBLaying);
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).animation = "follow blanket";
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).option = "";
		items[1].x = -199.75;
		items[1].y = -554.6;
		items[1].width = 614.00;
		items[1].height = 450.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBlanket(this: ICharlesDickensStoryLayout_dicBlanket) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-blanket.png", 0.500, 1.000);
	return this;
}
function CharlesDickensStoryLayout_slotBradBed(this: ICharlesDickensStoryLayout_slotBradBed) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch id=bed","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBed2.call(items[0] as ICharlesDickensStoryLayout_dicBed2);
		(items[0] as ICharlesDickensStoryLayout_dicBed2).animation = "squishStretch id=bed";
		(items[0] as ICharlesDickensStoryLayout_dicBed2).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBed2).option = "";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"follow bed","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicBLaying.call(items[1] as ICharlesDickensStoryLayout_dicBLaying);
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).animation = "follow bed";
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).option = "";
		items[1].x = -73.5;
		items[1].y = -706.35;
		items[1].width = 614.00;
		items[1].height = 450.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBed2(this: ICharlesDickensStoryLayout_dicBed2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBed1.call(items[0] as ICharlesDickensStoryLayout_dicBed1);
		items[0].x = -657;
		items[0].y = -560;
		items[0].width = 1314.00;
		items[0].height = 560.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBed1(this: ICharlesDickensStoryLayout_dicBed1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-bed.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_slotBradBeanBag(this: ICharlesDickensStoryLayout_slotBradBeanBag) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch id=beanbag","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBeanbag.call(items[0] as ICharlesDickensStoryLayout_dicBeanbag);
		(items[0] as ICharlesDickensStoryLayout_dicBeanbag).animation = "squishStretch id=beanbag";
		(items[0] as ICharlesDickensStoryLayout_dicBeanbag).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBeanbag).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 884.00;
		items[0].height = 652.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"follow beanbag","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicBLaying.call(items[1] as ICharlesDickensStoryLayout_dicBLaying);
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).animation = "follow beanbag";
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicBLaying).option = "";
		items[1].x = -239.9;
		items[1].y = -603.7;
		items[1].width = 614.00;
		items[1].height = 450.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBeanbag(this: ICharlesDickensStoryLayout_dicBeanbag) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-beanbag.png", 0.500, 1.000);
	return this;
}
export function CharlesDickensStoryLayout_scene2Imagination(this: ICharlesDickensStoryLayout_scene2Imagination) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch id=whale","isButton":true,"option":"whale"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicWhale2.call(items[0] as ICharlesDickensStoryLayout_dicWhale2);
		(items[0] as ICharlesDickensStoryLayout_dicWhale2).animation = "squishStretch id=whale";
		(items[0] as ICharlesDickensStoryLayout_dicWhale2).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicWhale2).option = "whale";
		items[0].x = 1056.1;
		items[0].y = 1296.7;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch id=spaceship","isButton":true,"option":"spaceship"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSpaceship2.call(items[1] as ICharlesDickensStoryLayout_dicSpaceship2);
		(items[1] as ICharlesDickensStoryLayout_dicSpaceship2).animation = "squishStretch id=spaceship";
		(items[1] as ICharlesDickensStoryLayout_dicSpaceship2).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicSpaceship2).option = "spaceship";
		items[1].x = 1022.65;
		items[1].y = 1162.75;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch id=castle","isButton":true,"option":"castle"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicCastle2.call(items[2] as ICharlesDickensStoryLayout_dicCastle2);
		(items[2] as ICharlesDickensStoryLayout_dicCastle2).animation = "squishStretch id=castle";
		(items[2] as ICharlesDickensStoryLayout_dicCastle2).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicCastle2).option = "castle";
		items[2].x = 1053.05;
		items[2].y = 1186.8;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"squishStretch id=airplane","isButton":true,"option":"airplane"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicAirplane2.call(items[3] as ICharlesDickensStoryLayout_dicAirplane2);
		(items[3] as ICharlesDickensStoryLayout_dicAirplane2).animation = "squishStretch id=airplane";
		(items[3] as ICharlesDickensStoryLayout_dicAirplane2).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicAirplane2).option = "airplane";
		items[3].x = 963.5;
		items[3].y = 1277.8;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_paperLayer.call(items[4] as ICharlesDickensStoryLayout_paperLayer);
		(items[4] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"follow whale","isButton":true,"option":"whale"});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_slotBradConfused.call(items[5] as ICharlesDickensStoryLayout_slotBradConfused);
		(items[5] as ICharlesDickensStoryLayout_slotBradConfused).animation = "follow whale";
		(items[5] as ICharlesDickensStoryLayout_slotBradConfused).isButton = true;
		(items[5] as ICharlesDickensStoryLayout_slotBradConfused).option = "whale";
		items[5].x = 732.05;
		items[5].y = 680.2;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"follow spaceship","isButton":true,"option":"spaceship"});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_slotBradConfused.call(items[6] as ICharlesDickensStoryLayout_slotBradConfused);
		(items[6] as ICharlesDickensStoryLayout_slotBradConfused).animation = "follow spaceship";
		(items[6] as ICharlesDickensStoryLayout_slotBradConfused).isButton = true;
		(items[6] as ICharlesDickensStoryLayout_slotBradConfused).option = "spaceship";
		items[6].x = 970.35;
		items[6].y = 658.15;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"follow castle","isButton":true,"option":"castle"});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_slotBradConfused.call(items[7] as ICharlesDickensStoryLayout_slotBradConfused);
		(items[7] as ICharlesDickensStoryLayout_slotBradConfused).animation = "follow castle";
		(items[7] as ICharlesDickensStoryLayout_slotBradConfused).isButton = true;
		(items[7] as ICharlesDickensStoryLayout_slotBradConfused).option = "castle";
		items[7].x = 978.9;
		items[7].y = 712.8;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"follow airplane","isButton":true,"option":"airplane"});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_slotBradConfused.call(items[8] as ICharlesDickensStoryLayout_slotBradConfused);
		(items[8] as ICharlesDickensStoryLayout_slotBradConfused).animation = "follow airplane";
		(items[8] as ICharlesDickensStoryLayout_slotBradConfused).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_slotBradConfused).option = "airplane";
		items[8].x = 713.6;
		items[8].y = 598.2;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicWhale2(this: ICharlesDickensStoryLayout_dicWhale2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicWhale1.call(items[0] as ICharlesDickensStoryLayout_dicWhale1);
		items[0].x = 0;
		items[0].y = -321;
		items[0].width = 1845.00;
		items[0].height = 642.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicWhale1(this: ICharlesDickensStoryLayout_dicWhale1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-whale.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicSpaceship2(this: ICharlesDickensStoryLayout_dicSpaceship2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSpaceship1.call(items[0] as ICharlesDickensStoryLayout_dicSpaceship1);
		items[0].x = 0;
		items[0].y = -366.5;
		items[0].width = 1680.00;
		items[0].height = 733.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSpaceship1(this: ICharlesDickensStoryLayout_dicSpaceship1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-spaceship.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicCastle2(this: ICharlesDickensStoryLayout_dicCastle2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicCastle1.call(items[0] as ICharlesDickensStoryLayout_dicCastle1);
		items[0].x = 0;
		items[0].y = -566;
		items[0].width = 992.00;
		items[0].height = 1132.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicCastle1(this: ICharlesDickensStoryLayout_dicCastle1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-castle.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicAirplane2(this: ICharlesDickensStoryLayout_dicAirplane2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicAirplane1.call(items[0] as ICharlesDickensStoryLayout_dicAirplane1);
		items[0].x = 0;
		items[0].y = -358.5;
		items[0].width = 2024.00;
		items[0].height = 717.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicAirplane1(this: ICharlesDickensStoryLayout_dicAirplane1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-airplane.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_paperLayer(this: ICharlesDickensStoryLayout_paperLayer) {
	return this;
}
function CharlesDickensStoryLayout_slotBradConfused(this: ICharlesDickensStoryLayout_slotBradConfused) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBSittingconfused.call(items[0] as ICharlesDickensStoryLayout_dicBSittingconfused);
		items[0].x = -189.5;
		items[0].y = -485.35;
		items[0].width = 379.00;
		items[0].height = 584.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBSittingconfused(this: ICharlesDickensStoryLayout_dicBSittingconfused) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-sittingconfused.png", 0.000, 0.000);
	return this;
}
export function CharlesDickensStoryLayout_scene3Location(this: ICharlesDickensStoryLayout_scene3Location) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"from whale","isButton":true,"option":"whale sea"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicWhale.call(items[0] as ICharlesDickensStoryLayout_dicWhale);
		(items[0] as ICharlesDickensStoryLayout_dicWhale).animation = "from whale";
		(items[0] as ICharlesDickensStoryLayout_dicWhale).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicWhale).option = "whale sea";
		items[0].x = 301.4;
		items[0].y = 606.65;
		if (items[0].scale) items[0].scale.x = 0.650;
		if (items[0].scale) items[0].scale.y = 0.650;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"from spaceship","isButton":true,"option":"spaceship sea"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSpaceship.call(items[1] as ICharlesDickensStoryLayout_dicSpaceship);
		(items[1] as ICharlesDickensStoryLayout_dicSpaceship).animation = "from spaceship";
		(items[1] as ICharlesDickensStoryLayout_dicSpaceship).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicSpaceship).option = "spaceship sea";
		items[1].x = 262.15;
		items[1].y = 596.7;
		if (items[1].scale) items[1].scale.x = 0.637;
		if (items[1].scale) items[1].scale.y = 0.637;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"from castle","isButton":true,"option":"castle sea"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicCastle.call(items[2] as ICharlesDickensStoryLayout_dicCastle);
		(items[2] as ICharlesDickensStoryLayout_dicCastle).animation = "from castle";
		(items[2] as ICharlesDickensStoryLayout_dicCastle).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicCastle).option = "castle sea";
		items[2].x = 369.9;
		items[2].y = 340.25;
		if (items[2].scale) items[2].scale.x = 0.637;
		if (items[2].scale) items[2].scale.y = 0.637;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"from airplane","isButton":true,"option":"airplane sea"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicAirplane.call(items[3] as ICharlesDickensStoryLayout_dicAirplane);
		(items[3] as ICharlesDickensStoryLayout_dicAirplane).animation = "from airplane";
		(items[3] as ICharlesDickensStoryLayout_dicAirplane).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicAirplane).option = "airplane sea";
		items[3].x = 171;
		items[3].y = 655.25;
		if (items[3].scale) items[3].scale.x = 0.546;
		if (items[3].scale) items[3].scale.y = 0.546;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"from whale time=1","isButton":true,"option":"whale space"});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicWhale.call(items[4] as ICharlesDickensStoryLayout_dicWhale);
		(items[4] as ICharlesDickensStoryLayout_dicWhale).animation = "from whale time=1";
		(items[4] as ICharlesDickensStoryLayout_dicWhale).isButton = true;
		(items[4] as ICharlesDickensStoryLayout_dicWhale).option = "whale space";
		items[4].x = 846;
		items[4].y = 1015.3;
		items[4].rotation = 0.1435;
		if (items[4].scale) items[4].scale.x = 0.650;
		if (items[4].scale) items[4].scale.y = 0.650;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"from spaceship time=1","isButton":true,"option":"spaceship space"});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicSpaceship.call(items[5] as ICharlesDickensStoryLayout_dicSpaceship);
		(items[5] as ICharlesDickensStoryLayout_dicSpaceship).animation = "from spaceship time=1";
		(items[5] as ICharlesDickensStoryLayout_dicSpaceship).isButton = true;
		(items[5] as ICharlesDickensStoryLayout_dicSpaceship).option = "spaceship space";
		items[5].x = 172.95;
		items[5].y = 1048.75;
		items[5].rotation = -0.1947;
		if (items[5].scale) items[5].scale.x = 0.635;
		if (items[5].scale) items[5].scale.y = 0.635;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"from castle time=1","isButton":true,"option":"castle space"});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicCastle.call(items[6] as ICharlesDickensStoryLayout_dicCastle);
		(items[6] as ICharlesDickensStoryLayout_dicCastle).animation = "from castle time=1";
		(items[6] as ICharlesDickensStoryLayout_dicCastle).isButton = true;
		(items[6] as ICharlesDickensStoryLayout_dicCastle).option = "castle space";
		items[6].x = 127.35;
		items[6].y = 941.45;
		items[6].rotation = -0.3656;
		if (items[6].scale) items[6].scale.x = 0.637;
		if (items[6].scale) items[6].scale.y = 0.637;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"from airplane time=1","isButton":true,"option":"airplane space"});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_dicAirplane.call(items[7] as ICharlesDickensStoryLayout_dicAirplane);
		(items[7] as ICharlesDickensStoryLayout_dicAirplane).animation = "from airplane time=1";
		(items[7] as ICharlesDickensStoryLayout_dicAirplane).isButton = true;
		(items[7] as ICharlesDickensStoryLayout_dicAirplane).option = "airplane space";
		items[7].x = 1101.45;
		items[7].y = 1514.4;
		items[7].rotation = -2.7669;
		if (items[7].scale) items[7].scale.x = 0.546;
		if (items[7].scale) items[7].scale.y = 0.546;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"from whale","isButton":true,"option":"whale baseballfield"});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicWhale.call(items[8] as ICharlesDickensStoryLayout_dicWhale);
		(items[8] as ICharlesDickensStoryLayout_dicWhale).animation = "from whale";
		(items[8] as ICharlesDickensStoryLayout_dicWhale).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicWhale).option = "whale baseballfield";
		items[8].x = 167.6;
		items[8].y = 979.4;
		if (items[8].scale) items[8].scale.x = 0.507;
		if (items[8].scale) items[8].scale.y = 0.507;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"from spaceship","isButton":true,"option":"spaceship baseballfield"});
	}
	if (items[9]) {
		CharlesDickensStoryLayout_dicSpaceship.call(items[9] as ICharlesDickensStoryLayout_dicSpaceship);
		(items[9] as ICharlesDickensStoryLayout_dicSpaceship).animation = "from spaceship";
		(items[9] as ICharlesDickensStoryLayout_dicSpaceship).isButton = true;
		(items[9] as ICharlesDickensStoryLayout_dicSpaceship).option = "spaceship baseballfield";
		items[9].x = 110.85;
		items[9].y = 818.2;
		if (items[9].scale) items[9].scale.x = 0.507;
		if (items[9].scale) items[9].scale.y = 0.507;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"from airplane","isButton":true,"option":"airplane baseballfield"});
	}
	if (items[10]) {
		CharlesDickensStoryLayout_dicAirplane.call(items[10] as ICharlesDickensStoryLayout_dicAirplane);
		(items[10] as ICharlesDickensStoryLayout_dicAirplane).animation = "from airplane";
		(items[10] as ICharlesDickensStoryLayout_dicAirplane).isButton = true;
		(items[10] as ICharlesDickensStoryLayout_dicAirplane).option = "airplane baseballfield";
		items[10].x = 132.15;
		items[10].y = 847.95;
		if (items[10].scale) items[10].scale.x = 0.429;
		if (items[10].scale) items[10].scale.y = 0.429;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"from castle","isButton":true,"option":"castle baseballfield"});
	}
	if (items[11]) {
		CharlesDickensStoryLayout_dicCastle.call(items[11] as ICharlesDickensStoryLayout_dicCastle);
		(items[11] as ICharlesDickensStoryLayout_dicCastle).animation = "from castle";
		(items[11] as ICharlesDickensStoryLayout_dicCastle).isButton = true;
		(items[11] as ICharlesDickensStoryLayout_dicCastle).option = "castle baseballfield";
		items[11].x = 61;
		items[11].y = 631.3;
		if (items[11].scale) items[11].scale.x = 0.507;
		if (items[11].scale) items[11].scale.y = 0.507;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"","isButton":false,"option":"sea"});
	}
	if (items[12]) {
		CharlesDickensStoryLayout_locationSea.call(items[12] as ICharlesDickensStoryLayout_locationSea);
		(items[12] as ICharlesDickensStoryLayout_locationSea).animation = "";
		(items[12] as ICharlesDickensStoryLayout_locationSea).isButton = false;
		(items[12] as ICharlesDickensStoryLayout_locationSea).option = "sea";
		items[12].x = 0;
		items[12].y = 0;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"","isButton":false,"option":"space"});
	}
	if (items[13]) {
		CharlesDickensStoryLayout_locationSpace.call(items[13] as ICharlesDickensStoryLayout_locationSpace);
		(items[13] as ICharlesDickensStoryLayout_locationSpace).animation = "";
		(items[13] as ICharlesDickensStoryLayout_locationSpace).isButton = false;
		(items[13] as ICharlesDickensStoryLayout_locationSpace).option = "space";
		items[13].x = 0;
		items[13].y = 0;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"","isButton":false,"option":"clouds"});
	}
	if (items[14]) {
		CharlesDickensStoryLayout_locationClouds.call(items[14] as ICharlesDickensStoryLayout_locationClouds);
		(items[14] as ICharlesDickensStoryLayout_locationClouds).animation = "";
		(items[14] as ICharlesDickensStoryLayout_locationClouds).isButton = false;
		(items[14] as ICharlesDickensStoryLayout_locationClouds).option = "clouds";
		items[14].x = 0;
		items[14].y = 0;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"scaleUp appear delay=0.4","isButton":false,"option":"baseballfield"});
	}
	if (items[15]) {
		CharlesDickensStoryLayout_locationStadium.call(items[15] as ICharlesDickensStoryLayout_locationStadium);
		(items[15] as ICharlesDickensStoryLayout_locationStadium).animation = "scaleUp appear delay=0.4";
		(items[15] as ICharlesDickensStoryLayout_locationStadium).isButton = false;
		(items[15] as ICharlesDickensStoryLayout_locationStadium).option = "baseballfield";
		items[15].x = 1024;
		items[15].y = 1536;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"isPaperLayer":true});
	}
	if (items[16]) {
		CharlesDickensStoryLayout_paperLayer.call(items[16] as ICharlesDickensStoryLayout_paperLayer);
		(items[16] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[16].x = 0;
		items[16].y = 0;
		items[16].width = 2048.00;
		items[16].height = 1536.00;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"id=whale","isButton":false,"option":"undefined"});
	}
	if (items[17]) {
		CharlesDickensStoryLayout_dicWhale.call(items[17] as ICharlesDickensStoryLayout_dicWhale);
		(items[17] as ICharlesDickensStoryLayout_dicWhale).animation = "id=whale";
		(items[17] as ICharlesDickensStoryLayout_dicWhale).isButton = false;
		(items[17] as ICharlesDickensStoryLayout_dicWhale).option = "undefined";
		items[17].x = 133.6;
		items[17].y = 654.7;
		if (items[17].onLayout) items[17].onLayout();
	}
	if (!items[18] && items.elementFactory) {
		items[18] = items.elementFactory(18,{"animation":"id=spaceship","isButton":true,"option":"undefined"});
	}
	if (items[18]) {
		CharlesDickensStoryLayout_dicSpaceship.call(items[18] as ICharlesDickensStoryLayout_dicSpaceship);
		(items[18] as ICharlesDickensStoryLayout_dicSpaceship).animation = "id=spaceship";
		(items[18] as ICharlesDickensStoryLayout_dicSpaceship).isButton = true;
		(items[18] as ICharlesDickensStoryLayout_dicSpaceship).option = "undefined";
		items[18].x = 182.65;
		items[18].y = 429.75;
		if (items[18].onLayout) items[18].onLayout();
	}
	if (!items[19] && items.elementFactory) {
		items[19] = items.elementFactory(19,{"animation":"id=castle","isButton":false,"option":"undefined"});
	}
	if (items[19]) {
		CharlesDickensStoryLayout_dicCastle.call(items[19] as ICharlesDickensStoryLayout_dicCastle);
		(items[19] as ICharlesDickensStoryLayout_dicCastle).animation = "id=castle";
		(items[19] as ICharlesDickensStoryLayout_dicCastle).isButton = false;
		(items[19] as ICharlesDickensStoryLayout_dicCastle).option = "undefined";
		items[19].x = 557.05;
		items[19].y = 54.8;
		if (items[19].onLayout) items[19].onLayout();
	}
	if (!items[20] && items.elementFactory) {
		items[20] = items.elementFactory(20,{"animation":"id=airplane","isButton":false,"option":"undefined"});
	}
	if (items[20]) {
		CharlesDickensStoryLayout_dicAirplane.call(items[20] as ICharlesDickensStoryLayout_dicAirplane);
		(items[20] as ICharlesDickensStoryLayout_dicAirplane).animation = "id=airplane";
		(items[20] as ICharlesDickensStoryLayout_dicAirplane).isButton = false;
		(items[20] as ICharlesDickensStoryLayout_dicAirplane).option = "undefined";
		items[20].x = -48.5;
		items[20].y = 560.8;
		if (items[20].onLayout) items[20].onLayout();
	}
	if (!items[21] && items.elementFactory) {
		items[21] = items.elementFactory(21,{"animation":"from spaceship","isButton":true,"option":"spaceship clouds"});
	}
	if (items[21]) {
		CharlesDickensStoryLayout_dicSpaceship.call(items[21] as ICharlesDickensStoryLayout_dicSpaceship);
		(items[21] as ICharlesDickensStoryLayout_dicSpaceship).animation = "from spaceship";
		(items[21] as ICharlesDickensStoryLayout_dicSpaceship).isButton = true;
		(items[21] as ICharlesDickensStoryLayout_dicSpaceship).option = "spaceship clouds";
		items[21].x = 497.7;
		items[21].y = 965.85;
		if (items[21].scale) items[21].scale.x = 0.596;
		if (items[21].scale) items[21].scale.y = 0.596;
		if (items[21].onLayout) items[21].onLayout();
	}
	if (!items[22] && items.elementFactory) {
		items[22] = items.elementFactory(22,{"animation":"from airplane","isButton":true,"option":"airplane clouds"});
	}
	if (items[22]) {
		CharlesDickensStoryLayout_dicAirplane.call(items[22] as ICharlesDickensStoryLayout_dicAirplane);
		(items[22] as ICharlesDickensStoryLayout_dicAirplane).animation = "from airplane";
		(items[22] as ICharlesDickensStoryLayout_dicAirplane).isButton = true;
		(items[22] as ICharlesDickensStoryLayout_dicAirplane).option = "airplane clouds";
		items[22].x = 498.4;
		items[22].y = 990.4;
		if (items[22].scale) items[22].scale.x = 0.511;
		if (items[22].scale) items[22].scale.y = 0.511;
		if (items[22].onLayout) items[22].onLayout();
	}
	if (!items[23] && items.elementFactory) {
		items[23] = items.elementFactory(23,{"animation":"from whale","isButton":true,"option":"whale clouds"});
	}
	if (items[23]) {
		CharlesDickensStoryLayout_dicWhale.call(items[23] as ICharlesDickensStoryLayout_dicWhale);
		(items[23] as ICharlesDickensStoryLayout_dicWhale).animation = "from whale";
		(items[23] as ICharlesDickensStoryLayout_dicWhale).isButton = true;
		(items[23] as ICharlesDickensStoryLayout_dicWhale).option = "whale clouds";
		items[23].x = 503.15;
		items[23].y = 1054.85;
		if (items[23].scale) items[23].scale.x = 0.608;
		if (items[23].scale) items[23].scale.y = 0.608;
		if (items[23].onLayout) items[23].onLayout();
	}
	if (!items[24] && items.elementFactory) {
		items[24] = items.elementFactory(24,{"animation":"from castle","isButton":true,"option":"castle clouds"});
	}
	if (items[24]) {
		CharlesDickensStoryLayout_dicCastle.call(items[24] as ICharlesDickensStoryLayout_dicCastle);
		(items[24] as ICharlesDickensStoryLayout_dicCastle).animation = "from castle";
		(items[24] as ICharlesDickensStoryLayout_dicCastle).isButton = true;
		(items[24] as ICharlesDickensStoryLayout_dicCastle).option = "castle clouds";
		items[24].x = 766.5;
		items[24].y = 774.3;
		if (items[24].scale) items[24].scale.x = 0.596;
		if (items[24].scale) items[24].scale.y = 0.596;
		if (items[24].onLayout) items[24].onLayout();
	}
	if (!items[25] && items.elementFactory) {
		items[25] = items.elementFactory(25,{"animation":"squishStretch appear delay=1.4","isButton":true,"option":"sea"});
	}
	if (items[25]) {
		CharlesDickensStoryLayout_dicBSea1.call(items[25] as ICharlesDickensStoryLayout_dicBSea1);
		(items[25] as ICharlesDickensStoryLayout_dicBSea1).animation = "squishStretch appear delay=1.4";
		(items[25] as ICharlesDickensStoryLayout_dicBSea1).isButton = true;
		(items[25] as ICharlesDickensStoryLayout_dicBSea1).option = "sea";
		items[25].x = 1041.75;
		items[25].y = 665.45;
		if (items[25].onLayout) items[25].onLayout();
	}
	if (!items[26] && items.elementFactory) {
		items[26] = items.elementFactory(26,{"animation":"squishStretch appear delay=1.6","isButton":false,"option":"sea"});
	}
	if (items[26]) {
		CharlesDickensStoryLayout_dicSeaBubbles3.call(items[26] as ICharlesDickensStoryLayout_dicSeaBubbles3);
		(items[26] as ICharlesDickensStoryLayout_dicSeaBubbles3).animation = "squishStretch appear delay=1.6";
		(items[26] as ICharlesDickensStoryLayout_dicSeaBubbles3).isButton = false;
		(items[26] as ICharlesDickensStoryLayout_dicSeaBubbles3).option = "sea";
		items[26].x = 1144;
		items[26].y = 421;
		if (items[26].onLayout) items[26].onLayout();
	}
	if (!items[27] && items.elementFactory) {
		items[27] = items.elementFactory(27,{"animation":"scaleUp appear delay=1","isButton":true,"option":"space"});
	}
	if (items[27]) {
		CharlesDickensStoryLayout_slotBradSpace.call(items[27] as ICharlesDickensStoryLayout_slotBradSpace);
		(items[27] as ICharlesDickensStoryLayout_slotBradSpace).animation = "scaleUp appear delay=1";
		(items[27] as ICharlesDickensStoryLayout_slotBradSpace).isButton = true;
		(items[27] as ICharlesDickensStoryLayout_slotBradSpace).option = "space";
		items[27].x = 1016.35;
		items[27].y = 733;
		if (items[27].onLayout) items[27].onLayout();
	}
	if (!items[28] && items.elementFactory) {
		items[28] = items.elementFactory(28,{"animation":"squishStretch appear delay=0.4","isButton":true,"option":"clouds"});
	}
	if (items[28]) {
		CharlesDickensStoryLayout_dicBFlying1.call(items[28] as ICharlesDickensStoryLayout_dicBFlying1);
		(items[28] as ICharlesDickensStoryLayout_dicBFlying1).animation = "squishStretch appear delay=0.4";
		(items[28] as ICharlesDickensStoryLayout_dicBFlying1).isButton = true;
		(items[28] as ICharlesDickensStoryLayout_dicBFlying1).option = "clouds";
		items[28].x = 964.7;
		items[28].y = 579;
		if (items[28].onLayout) items[28].onLayout();
	}
	if (!items[29] && items.elementFactory) {
		items[29] = items.elementFactory(29,{"animation":"squishStretch appear delay=1","isButton":true,"option":"baseballfield"});
	}
	if (items[29]) {
		CharlesDickensStoryLayout_dicBBaseball1.call(items[29] as ICharlesDickensStoryLayout_dicBBaseball1);
		(items[29] as ICharlesDickensStoryLayout_dicBBaseball1).animation = "squishStretch appear delay=1";
		(items[29] as ICharlesDickensStoryLayout_dicBBaseball1).isButton = true;
		(items[29] as ICharlesDickensStoryLayout_dicBBaseball1).option = "baseballfield";
		items[29].x = 1020.05;
		items[29].y = 1186.65;
		if (items[29].onLayout) items[29].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicWhale(this: ICharlesDickensStoryLayout_dicWhale) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicWhale1.call(items[0] as ICharlesDickensStoryLayout_dicWhale1);
		items[0].x = 922.5;
		items[0].y = 321;
		items[0].width = 1845.00;
		items[0].height = 642.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSpaceship(this: ICharlesDickensStoryLayout_dicSpaceship) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSpaceship1.call(items[0] as ICharlesDickensStoryLayout_dicSpaceship1);
		items[0].x = 840;
		items[0].y = 366.5;
		items[0].width = 1680.00;
		items[0].height = 733.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicCastle(this: ICharlesDickensStoryLayout_dicCastle) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicCastle1.call(items[0] as ICharlesDickensStoryLayout_dicCastle1);
		items[0].x = 496;
		items[0].y = 566;
		items[0].width = 992.00;
		items[0].height = 1132.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicAirplane(this: ICharlesDickensStoryLayout_dicAirplane) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicAirplane1.call(items[0] as ICharlesDickensStoryLayout_dicAirplane1);
		items[0].x = 1012;
		items[0].y = 358.5;
		items[0].width = 2024.00;
		items[0].height = 717.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_locationSea(this: ICharlesDickensStoryLayout_locationSea) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch appear delay=0.8","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSeaPlant3.call(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3);
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3).animation = "squishStretch appear delay=0.8";
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3).option = "";
		items[0].x = 1833;
		items[0].y = 1308.6;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"squishStretch appear delay=1","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSeaPlant2.call(items[1] as ICharlesDickensStoryLayout_dicSeaPlant2);
		(items[1] as ICharlesDickensStoryLayout_dicSeaPlant2).animation = "squishStretch appear delay=1";
		(items[1] as ICharlesDickensStoryLayout_dicSeaPlant2).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicSeaPlant2).option = "";
		items[1].x = 1409;
		items[1].y = 1163.5;
		items[1].width = 279.00;
		items[1].height = 322.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"squishStretch appear delay=0.6","isButton":false,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSeaPlant1.call(items[2] as ICharlesDickensStoryLayout_dicSeaPlant1);
		(items[2] as ICharlesDickensStoryLayout_dicSeaPlant1).animation = "squishStretch appear delay=0.6";
		(items[2] as ICharlesDickensStoryLayout_dicSeaPlant1).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicSeaPlant1).option = "";
		items[2].x = 287.95;
		items[2].y = 1235;
		items[2].width = 293.00;
		items[2].height = 341.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"slideIn right appear delay=0.5 speed=0.6","isButton":false,"option":""});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicSeaFish2.call(items[3] as ICharlesDickensStoryLayout_dicSeaFish2);
		(items[3] as ICharlesDickensStoryLayout_dicSeaFish2).animation = "slideIn right appear delay=0.5 speed=0.6";
		(items[3] as ICharlesDickensStoryLayout_dicSeaFish2).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_dicSeaFish2).option = "";
		items[3].x = 1626.3;
		items[3].y = 842;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"slideIn left appear delay=0.3 speed=0.6","isButton":false,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicSeaFish1.call(items[4] as ICharlesDickensStoryLayout_dicSeaFish1);
		(items[4] as ICharlesDickensStoryLayout_dicSeaFish1).animation = "slideIn left appear delay=0.3 speed=0.6";
		(items[4] as ICharlesDickensStoryLayout_dicSeaFish1).isButton = false;
		(items[4] as ICharlesDickensStoryLayout_dicSeaFish1).option = "";
		items[4].x = 381.45;
		items[4].y = 955;
		items[4].width = 217.00;
		items[4].height = 78.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch appear delay=1.4","isButton":false,"option":""});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicSeaBubbles2.call(items[5] as ICharlesDickensStoryLayout_dicSeaBubbles2);
		(items[5] as ICharlesDickensStoryLayout_dicSeaBubbles2).animation = "squishStretch appear delay=1.4";
		(items[5] as ICharlesDickensStoryLayout_dicSeaBubbles2).isButton = false;
		(items[5] as ICharlesDickensStoryLayout_dicSeaBubbles2).option = "";
		items[5].x = 1695.05;
		items[5].y = 619;
		items[5].width = 499.00;
		items[5].height = 427.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch appear delay=1.2","isButton":false,"option":""});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicSeaBubbles1.call(items[6] as ICharlesDickensStoryLayout_dicSeaBubbles1);
		(items[6] as ICharlesDickensStoryLayout_dicSeaBubbles1).animation = "squishStretch appear delay=1.2";
		(items[6] as ICharlesDickensStoryLayout_dicSeaBubbles1).isButton = false;
		(items[6] as ICharlesDickensStoryLayout_dicSeaBubbles1).option = "";
		items[6].x = 375;
		items[6].y = 666;
		items[6].width = 352.00;
		items[6].height = 454.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSeaPlant3(this: ICharlesDickensStoryLayout_dicSeaPlant3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSeaPlant31.call(items[0] as ICharlesDickensStoryLayout_dicSeaPlant31);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 374.00;
		items[0].height = 541.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSeaPlant31(this: ICharlesDickensStoryLayout_dicSeaPlant31) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-plant-3.png", 0.500, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicSeaPlant2(this: ICharlesDickensStoryLayout_dicSeaPlant2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-plant-2.png", 0.502, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicSeaPlant1(this: ICharlesDickensStoryLayout_dicSeaPlant1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-plant-1.png", 0.502, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicSeaFish2(this: ICharlesDickensStoryLayout_dicSeaFish2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSeaFish21.call(items[0] as ICharlesDickensStoryLayout_dicSeaFish21);
		items[0].x = -0.5;
		items[0].y = 0;
		items[0].width = 187.00;
		items[0].height = 68.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSeaFish21(this: ICharlesDickensStoryLayout_dicSeaFish21) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-fish-2.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicSeaFish1(this: ICharlesDickensStoryLayout_dicSeaFish1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-fish-1.png", 0.502, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicSeaBubbles2(this: ICharlesDickensStoryLayout_dicSeaBubbles2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-bubbles-2.png", 0.501, 0.501);
	return this;
}
function CharlesDickensStoryLayout_dicSeaBubbles1(this: ICharlesDickensStoryLayout_dicSeaBubbles1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-bubbles-1.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_locationSpace(this: ICharlesDickensStoryLayout_locationSpace) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"slideIn down ease=backOut time=0.6 delay=0.8","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSpacePlanet3.call(items[0] as ICharlesDickensStoryLayout_dicSpacePlanet3);
		(items[0] as ICharlesDickensStoryLayout_dicSpacePlanet3).animation = "slideIn down ease=backOut time=0.6 delay=0.8";
		(items[0] as ICharlesDickensStoryLayout_dicSpacePlanet3).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicSpacePlanet3).option = "";
		items[0].x = -87.45;
		items[0].y = 567.8;
		items[0].width = 1298.00;
		items[0].height = 566.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"slideIn down ease=backOut time=0.6 delay=0.6","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSpaceSatellite.call(items[1] as ICharlesDickensStoryLayout_dicSpaceSatellite);
		(items[1] as ICharlesDickensStoryLayout_dicSpaceSatellite).animation = "slideIn down ease=backOut time=0.6 delay=0.6";
		(items[1] as ICharlesDickensStoryLayout_dicSpaceSatellite).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicSpaceSatellite).option = "";
		items[1].x = 1468.65;
		items[1].y = 503.75;
		items[1].width = 489.00;
		items[1].height = 331.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"slideIn down ease=backOut time=0.6 delay=1.2","isButton":false,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSpacePlanet4.call(items[2] as ICharlesDickensStoryLayout_dicSpacePlanet4);
		(items[2] as ICharlesDickensStoryLayout_dicSpacePlanet4).animation = "slideIn down ease=backOut time=0.6 delay=1.2";
		(items[2] as ICharlesDickensStoryLayout_dicSpacePlanet4).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicSpacePlanet4).option = "";
		items[2].x = 59.3;
		items[2].y = 180.4;
		items[2].width = 136.00;
		items[2].height = 135.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"slideIn down ease=backOut time=0.6 delay=1","isButton":false,"option":""});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicSpacePlanet2.call(items[3] as ICharlesDickensStoryLayout_dicSpacePlanet2);
		(items[3] as ICharlesDickensStoryLayout_dicSpacePlanet2).animation = "slideIn down ease=backOut time=0.6 delay=1";
		(items[3] as ICharlesDickensStoryLayout_dicSpacePlanet2).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_dicSpacePlanet2).option = "";
		items[3].x = 1153.45;
		items[3].y = 402.95;
		items[3].width = 269.00;
		items[3].height = 268.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSpacePlanet3(this: ICharlesDickensStoryLayout_dicSpacePlanet3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-planet-3.png", 0.000, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicSpaceSatellite(this: ICharlesDickensStoryLayout_dicSpaceSatellite) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-satellite.png", 0.000, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicSpacePlanet4(this: ICharlesDickensStoryLayout_dicSpacePlanet4) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-planet-4.png", 0.000, 1.000);
	return this;
}
function CharlesDickensStoryLayout_dicSpacePlanet2(this: ICharlesDickensStoryLayout_dicSpacePlanet2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-space-planet-2.png", 0.000, 1.000);
	return this;
}
function CharlesDickensStoryLayout_locationClouds(this: ICharlesDickensStoryLayout_locationClouds) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicCloudsFront.call(items[0] as ICharlesDickensStoryLayout_dicCloudsFront);
		items[0].x = 2011.45;
		items[0].y = 518.65;
		items[0].width = -2957.00;
		items[0].height = 1024.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicCloud3.call(items[1] as ICharlesDickensStoryLayout_dicCloud3);
		items[1].x = 1769.6;
		items[1].y = 53.1;
		items[1].width = 918.00;
		items[1].height = 365.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicCloud2.call(items[2] as ICharlesDickensStoryLayout_dicCloud2);
		items[2].x = 1303.2;
		items[2].y = 518.65;
		items[2].width = 1190.00;
		items[2].height = 501.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicCloud1.call(items[3] as ICharlesDickensStoryLayout_dicCloud1);
		items[3].x = -573.1;
		items[3].y = 208.45;
		items[3].width = 1067.00;
		items[3].height = 183.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicCloudsFront(this: ICharlesDickensStoryLayout_dicCloudsFront) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-clouds-front.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicCloud3(this: ICharlesDickensStoryLayout_dicCloud3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-cloud-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicCloud2(this: ICharlesDickensStoryLayout_dicCloud2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-cloud-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicCloud1(this: ICharlesDickensStoryLayout_dicCloud1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-cloud-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_locationStadium(this: ICharlesDickensStoryLayout_locationStadium) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBaseballField.call(items[0] as ICharlesDickensStoryLayout_dicBaseballField);
		items[0].x = -1664;
		items[0].y = -422;
		items[0].width = 3328.00;
		items[0].height = 422.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,undefined);
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicBaseballLights.call(items[1] as ICharlesDickensStoryLayout_dicBaseballLights);
		items[1].x = -739.8;
		items[1].y = -634.75;
		items[1].width = 290.00;
		items[1].height = 266.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,undefined);
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicBaseballLights.call(items[2] as ICharlesDickensStoryLayout_dicBaseballLights);
		items[2].x = 735.35;
		items[2].y = -634.7;
		items[2].width = -290.00;
		items[2].height = 266.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,undefined);
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicBaseballBaseball.call(items[3] as ICharlesDickensStoryLayout_dicBaseballBaseball);
		items[3].x = 453.4;
		items[3].y = -366.6;
		items[3].width = 73.00;
		items[3].height = 70.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,undefined);
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicBaseballBat.call(items[4] as ICharlesDickensStoryLayout_dicBaseballBat);
		items[4].x = 341.1;
		items[4].y = -333.6;
		items[4].width = 269.00;
		items[4].height = 90.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBaseballField(this: ICharlesDickensStoryLayout_dicBaseballField) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-baseball-field.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBaseballLights(this: ICharlesDickensStoryLayout_dicBaseballLights) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-baseball-lights.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBaseballBaseball(this: ICharlesDickensStoryLayout_dicBaseballBaseball) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-baseball-baseball.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBaseballBat(this: ICharlesDickensStoryLayout_dicBaseballBat) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-baseball-bat.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBSea1(this: ICharlesDickensStoryLayout_dicBSea1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=1.6 time=1.4","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBSea.call(items[0] as ICharlesDickensStoryLayout_dicBSea);
		(items[0] as ICharlesDickensStoryLayout_dicBSea).animation = "float delay=1.6 time=1.4";
		(items[0] as ICharlesDickensStoryLayout_dicBSea).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBSea).option = "";
		items[0].x = -206.5;
		items[0].y = -344.5;
		items[0].width = 413.00;
		items[0].height = 689.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBSea(this: ICharlesDickensStoryLayout_dicBSea) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-sea.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicSeaBubbles3(this: ICharlesDickensStoryLayout_dicSeaBubbles3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"float delay=1.6 speed=0.8 time=1.4","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSeaBubbles31.call(items[0] as ICharlesDickensStoryLayout_dicSeaBubbles31);
		(items[0] as ICharlesDickensStoryLayout_dicSeaBubbles31).animation = "float delay=1.6 speed=0.8 time=1.4";
		(items[0] as ICharlesDickensStoryLayout_dicSeaBubbles31).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicSeaBubbles31).option = "";
		items[0].x = 0;
		items[0].y = -0.5;
		items[0].width = 304.00;
		items[0].height = 427.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSeaBubbles31(this: ICharlesDickensStoryLayout_dicSeaBubbles31) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-sea-bubbles-3.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_slotBradSpace(this: ICharlesDickensStoryLayout_slotBradSpace) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"rotate delay=1 time=14","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBSpace.call(items[0] as ICharlesDickensStoryLayout_dicBSpace);
		(items[0] as ICharlesDickensStoryLayout_dicBSpace).animation = "rotate delay=1 time=14";
		(items[0] as ICharlesDickensStoryLayout_dicBSpace).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBSpace).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 645.00;
		items[0].height = 552.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBSpace(this: ICharlesDickensStoryLayout_dicBSpace) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-space.png", 0.564, 0.424);
	return this;
}
function CharlesDickensStoryLayout_dicBFlying1(this: ICharlesDickensStoryLayout_dicBFlying1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"rotate yoyo time=4 delay=0.4","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBFlying.call(items[0] as ICharlesDickensStoryLayout_dicBFlying);
		(items[0] as ICharlesDickensStoryLayout_dicBFlying).animation = "rotate yoyo time=4 delay=0.4";
		(items[0] as ICharlesDickensStoryLayout_dicBFlying).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBFlying).option = "";
		items[0].x = 0;
		items[0].y = 0;
		items[0].rotation = -0.1745;
		items[0].width = 1136.03;
		items[0].height = 574.02;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBFlying(this: ICharlesDickensStoryLayout_dicBFlying) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-flying.png", 0.575, 0.566);
	return this;
}
function CharlesDickensStoryLayout_dicBBaseball1(this: ICharlesDickensStoryLayout_dicBBaseball1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBBaseball.call(items[0] as ICharlesDickensStoryLayout_dicBBaseball);
		items[0].x = -223;
		items[0].y = -662;
		items[0].width = 446.00;
		items[0].height = 662.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBBaseball(this: ICharlesDickensStoryLayout_dicBBaseball) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-baseball.png", 0.000, 0.000);
	return this;
}
export function CharlesDickensStoryLayout_scene4Chair(this: ICharlesDickensStoryLayout_scene4Chair) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"sea"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_locationSea1.call(items[0] as ICharlesDickensStoryLayout_locationSea1);
		(items[0] as ICharlesDickensStoryLayout_locationSea1).animation = "";
		(items[0] as ICharlesDickensStoryLayout_locationSea1).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_locationSea1).option = "sea";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"static","isButton":false,"option":"space"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_locationSpace.call(items[1] as ICharlesDickensStoryLayout_locationSpace);
		(items[1] as ICharlesDickensStoryLayout_locationSpace).animation = "static";
		(items[1] as ICharlesDickensStoryLayout_locationSpace).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_locationSpace).option = "space";
		items[1].x = 0;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"static","isButton":false,"option":"clouds"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_locationClouds.call(items[2] as ICharlesDickensStoryLayout_locationClouds);
		(items[2] as ICharlesDickensStoryLayout_locationClouds).animation = "static";
		(items[2] as ICharlesDickensStoryLayout_locationClouds).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_locationClouds).option = "clouds";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"static","isButton":false,"option":"baseballfield"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_locationStadium.call(items[3] as ICharlesDickensStoryLayout_locationStadium);
		(items[3] as ICharlesDickensStoryLayout_locationStadium).animation = "static";
		(items[3] as ICharlesDickensStoryLayout_locationStadium).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_locationStadium).option = "baseballfield";
		items[3].x = 1024;
		items[3].y = 1536;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_paperLayer.call(items[4] as ICharlesDickensStoryLayout_paperLayer);
		(items[4] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		CharlesDickensStoryLayout_slotChair.call(items[5] as ICharlesDickensStoryLayout_slotChair);
		items[5].x = 0;
		items[5].y = 0;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"isPaperLayer":true});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_paperLayer.call(items[6] as ICharlesDickensStoryLayout_paperLayer);
		(items[6] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[6].x = 0;
		items[6].y = 0;
		items[6].width = 2048.00;
		items[6].height = 1536.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":false,"option":"sea"});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_slotLocationSeaRight.call(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight);
		(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight).animation = "";
		(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight).isButton = false;
		(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight).option = "sea";
		items[7].x = 1445.05;
		items[7].y = 405;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch","isButton":true,"option":"popcorn"});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicBExcited1.call(items[8] as ICharlesDickensStoryLayout_dicBExcited1);
		(items[8] as ICharlesDickensStoryLayout_dicBExcited1).animation = "squishStretch";
		(items[8] as ICharlesDickensStoryLayout_dicBExcited1).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicBExcited1).option = "popcorn";
		items[8].x = 403;
		items[8].y = 1255.75;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"squishStretch","isButton":true,"option":"balloons"});
	}
	if (items[9]) {
		CharlesDickensStoryLayout_dicBPointing1.call(items[9] as ICharlesDickensStoryLayout_dicBPointing1);
		(items[9] as ICharlesDickensStoryLayout_dicBPointing1).animation = "squishStretch";
		(items[9] as ICharlesDickensStoryLayout_dicBPointing1).isButton = true;
		(items[9] as ICharlesDickensStoryLayout_dicBPointing1).option = "balloons";
		items[9].x = 406.05;
		items[9].y = 1256.95;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"squishStretch","isButton":true,"option":"chickens"});
	}
	if (items[10]) {
		CharlesDickensStoryLayout_dicBConcerned1.call(items[10] as ICharlesDickensStoryLayout_dicBConcerned1);
		(items[10] as ICharlesDickensStoryLayout_dicBConcerned1).animation = "squishStretch";
		(items[10] as ICharlesDickensStoryLayout_dicBConcerned1).isButton = true;
		(items[10] as ICharlesDickensStoryLayout_dicBConcerned1).option = "chickens";
		items[10].x = 512.25;
		items[10].y = 1259.2;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"squishStretch","isButton":true,"option":"worms"});
	}
	if (items[11]) {
		CharlesDickensStoryLayout_dicBScared1.call(items[11] as ICharlesDickensStoryLayout_dicBScared1);
		(items[11] as ICharlesDickensStoryLayout_dicBScared1).animation = "squishStretch";
		(items[11] as ICharlesDickensStoryLayout_dicBScared1).isButton = true;
		(items[11] as ICharlesDickensStoryLayout_dicBScared1).option = "worms";
		items[11].x = 379.45;
		items[11].y = 1218.35;
		if (items[11].onLayout) items[11].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_locationSea1(this: ICharlesDickensStoryLayout_locationSea1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSeaPlant2.call(items[0] as ICharlesDickensStoryLayout_dicSeaPlant2);
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant2).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant2).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant2).option = "";
		items[0].x = 1409;
		items[0].y = 1163.5;
		items[0].width = 279.00;
		items[0].height = 322.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSeaPlant1.call(items[1] as ICharlesDickensStoryLayout_dicSeaPlant1);
		(items[1] as ICharlesDickensStoryLayout_dicSeaPlant1).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicSeaPlant1).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicSeaPlant1).option = "";
		items[1].x = 287.95;
		items[1].y = 1235;
		items[1].width = 293.00;
		items[1].height = 341.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSeaFish1.call(items[2] as ICharlesDickensStoryLayout_dicSeaFish1);
		(items[2] as ICharlesDickensStoryLayout_dicSeaFish1).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicSeaFish1).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicSeaFish1).option = "";
		items[2].x = 381.45;
		items[2].y = 955;
		items[2].width = 217.00;
		items[2].height = 78.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":""});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicSeaBubbles1.call(items[3] as ICharlesDickensStoryLayout_dicSeaBubbles1);
		(items[3] as ICharlesDickensStoryLayout_dicSeaBubbles1).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicSeaBubbles1).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_dicSeaBubbles1).option = "";
		items[3].x = 375;
		items[3].y = 666;
		items[3].width = 352.00;
		items[3].height = 454.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_slotChair(this: ICharlesDickensStoryLayout_slotChair) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"popcorn"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicPopcorn12.call(items[0] as ICharlesDickensStoryLayout_dicPopcorn12);
		(items[0] as ICharlesDickensStoryLayout_dicPopcorn12).animation = "squishStretch appear delay=0.2";
		(items[0] as ICharlesDickensStoryLayout_dicPopcorn12).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicPopcorn12).option = "popcorn";
		items[0].x = 1204.95;
		items[0].y = 1254.85;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"children:from balloon time=2 ease=backOut","isButton":false,"option":"balloons"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_slotBallons.call(items[1] as ICharlesDickensStoryLayout_slotBallons);
		(items[1] as ICharlesDickensStoryLayout_slotBallons).animation = "children:from balloon time=2 ease=backOut";
		(items[1] as ICharlesDickensStoryLayout_slotBallons).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_slotBallons).option = "balloons";
		items[1].x = 1373.8;
		items[1].y = 670.8;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"children:squishStretch appear delay=0.2-0.8","isButton":false,"option":"chickens"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_slotChickens.call(items[2] as ICharlesDickensStoryLayout_slotChickens);
		(items[2] as ICharlesDickensStoryLayout_slotChickens).animation = "children:squishStretch appear delay=0.2-0.8";
		(items[2] as ICharlesDickensStoryLayout_slotChickens).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_slotChickens).option = "chickens";
		items[2].x = 1318.85;
		items[2].y = 1082.65;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"worms"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicWorms1.call(items[3] as ICharlesDickensStoryLayout_dicWorms1);
		(items[3] as ICharlesDickensStoryLayout_dicWorms1).animation = "squishStretch appear delay=0.2";
		(items[3] as ICharlesDickensStoryLayout_dicWorms1).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicWorms1).option = "worms";
		items[3].x = 1145.5;
		items[3].y = 1300.45;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicPopcorn12(this: ICharlesDickensStoryLayout_dicPopcorn12) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicPopcorn.call(items[0] as ICharlesDickensStoryLayout_dicPopcorn);
		items[0].x = -594;
		items[0].y = -678;
		items[0].width = 1188.00;
		items[0].height = 678.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"from p1 bezier appear ease=bounceOut time=1 delay=1","isButton":false,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicPopcorn1.call(items[1] as ICharlesDickensStoryLayout_dicPopcorn1);
		(items[1] as ICharlesDickensStoryLayout_dicPopcorn1).animation = "from p1 bezier appear ease=bounceOut time=1 delay=1";
		(items[1] as ICharlesDickensStoryLayout_dicPopcorn1).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicPopcorn1).option = "";
		items[1].x = -289.5;
		items[1].y = -53.2;
		items[1].rotation = 2.3609;
		items[1].width = 107.00;
		items[1].height = 91.00;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"from p2 bezier appear ease=bounceOut time=1 delay=0.8","isButton":false,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicPopcorn2.call(items[2] as ICharlesDickensStoryLayout_dicPopcorn2);
		(items[2] as ICharlesDickensStoryLayout_dicPopcorn2).animation = "from p2 bezier appear ease=bounceOut time=1 delay=0.8";
		(items[2] as ICharlesDickensStoryLayout_dicPopcorn2).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicPopcorn2).option = "";
		items[2].x = 435.6;
		items[2].y = -19.75;
		items[2].width = 88.00;
		items[2].height = 73.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"from p3 bezier appear ease=bounceOut time=1 delay=0.6","isButton":false,"option":""});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicPopcorn3.call(items[3] as ICharlesDickensStoryLayout_dicPopcorn3);
		(items[3] as ICharlesDickensStoryLayout_dicPopcorn3).animation = "from p3 bezier appear ease=bounceOut time=1 delay=0.6";
		(items[3] as ICharlesDickensStoryLayout_dicPopcorn3).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_dicPopcorn3).option = "";
		items[3].x = -468.9;
		items[3].y = -130;
		items[3].width = 69.00;
		items[3].height = 52.00;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"from p4 bezier appear ease=bounceOut time=1 delay=1.2","isButton":false,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicPopcorn4.call(items[4] as ICharlesDickensStoryLayout_dicPopcorn4);
		(items[4] as ICharlesDickensStoryLayout_dicPopcorn4).animation = "from p4 bezier appear ease=bounceOut time=1 delay=1.2";
		(items[4] as ICharlesDickensStoryLayout_dicPopcorn4).isButton = false;
		(items[4] as ICharlesDickensStoryLayout_dicPopcorn4).option = "";
		items[4].x = 66.55;
		items[4].y = -52.1;
		items[4].width = 91.00;
		items[4].height = 68.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"id=p3","isButton":false,"option":"undefined"});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicPopcorn3.call(items[5] as ICharlesDickensStoryLayout_dicPopcorn3);
		(items[5] as ICharlesDickensStoryLayout_dicPopcorn3).animation = "id=p3";
		(items[5] as ICharlesDickensStoryLayout_dicPopcorn3).isButton = false;
		(items[5] as ICharlesDickensStoryLayout_dicPopcorn3).option = "undefined";
		items[5].x = -215.5;
		items[5].y = -367.65;
		items[5].rotation = 0.9894;
		items[5].width = 69.00;
		items[5].height = 52.00;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"id=p1","isButton":false,"option":"undefined"});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicPopcorn1.call(items[6] as ICharlesDickensStoryLayout_dicPopcorn1);
		(items[6] as ICharlesDickensStoryLayout_dicPopcorn1).animation = "id=p1";
		(items[6] as ICharlesDickensStoryLayout_dicPopcorn1).isButton = false;
		(items[6] as ICharlesDickensStoryLayout_dicPopcorn1).option = "undefined";
		items[6].x = -40.25;
		items[6].y = -418.6;
		items[6].rotation = -0.4525;
		items[6].width = 107.00;
		items[6].height = 91.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"id=p4","isButton":false,"option":"undefined"});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_dicPopcorn4.call(items[7] as ICharlesDickensStoryLayout_dicPopcorn4);
		(items[7] as ICharlesDickensStoryLayout_dicPopcorn4).animation = "id=p4";
		(items[7] as ICharlesDickensStoryLayout_dicPopcorn4).isButton = false;
		(items[7] as ICharlesDickensStoryLayout_dicPopcorn4).option = "undefined";
		items[7].x = 333.8;
		items[7].y = -373.8;
		items[7].rotation = 1.4656;
		items[7].width = 91.00;
		items[7].height = 68.00;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"id=p2","isButton":false,"option":"undefined"});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicPopcorn2.call(items[8] as ICharlesDickensStoryLayout_dicPopcorn2);
		(items[8] as ICharlesDickensStoryLayout_dicPopcorn2).animation = "id=p2";
		(items[8] as ICharlesDickensStoryLayout_dicPopcorn2).isButton = false;
		(items[8] as ICharlesDickensStoryLayout_dicPopcorn2).option = "undefined";
		items[8].x = 122.45;
		items[8].y = -331.9;
		items[8].rotation = -1.5839;
		items[8].width = 88.00;
		items[8].height = 73.00;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicPopcorn(this: ICharlesDickensStoryLayout_dicPopcorn) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicPopcorn1(this: ICharlesDickensStoryLayout_dicPopcorn1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-1.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicPopcorn2(this: ICharlesDickensStoryLayout_dicPopcorn2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-2.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicPopcorn3(this: ICharlesDickensStoryLayout_dicPopcorn3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-3.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicPopcorn4(this: ICharlesDickensStoryLayout_dicPopcorn4) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-popcorn-4.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_slotBallons(this: ICharlesDickensStoryLayout_slotBallons) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[0] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[0] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[0].x = -163.25;
		items[0].y = 129.2;
		items[0].rotation = 0.0873;
		if (items[0].scale) items[0].scale.x = 0.906;
		if (items[0].scale) items[0].scale.y = 0.921;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[1] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[1] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[1].x = -426.9;
		items[1].y = 107.75;
		items[1].rotation = -0.0685;
		if (items[1].scale) items[1].scale.x = 0.816;
		if (items[1].scale) items[1].scale.y = 0.875;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[2] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[2] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[2].x = -450.35;
		items[2].y = -113;
		if (items[2].scale) items[2].scale.x = 0.729;
		if (items[2].scale) items[2].scale.y = 0.802;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[3] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[3] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[3].x = -545.05;
		items[3].y = -248.2;
		items[3].rotation = -0.1874;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"","isButton":true,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[4] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[4] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[4] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[4] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[4].x = -552.8;
		items[4].y = -155.15;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"","isButton":true,"option":""});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[5] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[5] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[5] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[5] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[5].x = -298.1;
		items[5].y = -432.25;
		if (items[5].scale) items[5].scale.x = 0.650;
		if (items[5].scale) items[5].scale.y = 0.694;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"","isButton":true,"option":""});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[6] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[6] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[6] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[6] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[6].x = -27.6;
		items[6].y = -259.65;
		items[6].rotation = 0.2790;
		if (items[6].scale) items[6].scale.x = 0.800;
		if (items[6].scale) items[6].scale.y = 0.800;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":true,"option":""});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[7] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[7] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[7] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[7] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[7].x = 256.15;
		items[7].y = -450.5;
		items[7].rotation = 0.0211;
		if (items[7].scale) items[7].scale.x = 0.571;
		if (items[7].scale) items[7].scale.y = 0.571;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"","isButton":true,"option":""});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[8] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[8] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[8] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[8].x = 296;
		items[8].y = -375.05;
		items[8].rotation = 1.0376;
		if (items[8].scale) items[8].scale.x = 0.698;
		if (items[8].scale) items[8].scale.y = 0.698;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"","isButton":true,"option":""});
	}
	if (items[9]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[9] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[9] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[9] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[9] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[9].x = 571.8;
		items[9].y = -237.6;
		items[9].rotation = 0.2012;
		if (items[9].scale) items[9].scale.x = 0.800;
		if (items[9].scale) items[9].scale.y = 0.800;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"","isButton":true,"option":""});
	}
	if (items[10]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[10] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[10] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[10] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[10] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[10].x = 33;
		items[10].y = -16.35;
		items[10].rotation = -0.1869;
		if (items[10].scale) items[10].scale.x = 0.861;
		if (items[10].scale) items[10].scale.y = 0.875;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"","isButton":true,"option":""});
	}
	if (items[11]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[11] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[11] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[11] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[11] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[11].x = -223.55;
		items[11].y = -9.4;
		items[11].rotation = 0.0004;
		if (items[11].scale) items[11].scale.x = 0.906;
		if (items[11].scale) items[11].scale.y = 0.921;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"","isButton":true,"option":""});
	}
	if (items[12]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[12] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[12] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[12] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[12] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[12].x = -303.15;
		items[12].y = 242.4;
		items[12].rotation = 0.2269;
		if (items[12].scale) items[12].scale.x = 0.988;
		if (items[12].scale) items[12].scale.y = 1.004;
		if (items[12].onLayout) items[12].onLayout();
	}
	if (!items[13] && items.elementFactory) {
		items[13] = items.elementFactory(13,{"animation":"","isButton":true,"option":""});
	}
	if (items[13]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[13] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[13] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[13] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[13] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[13].x = -547.5;
		items[13].y = 397;
		items[13].rotation = -0.3443;
		if (items[13].scale) items[13].scale.x = 0.800;
		if (items[13].scale) items[13].scale.y = 0.813;
		if (items[13].onLayout) items[13].onLayout();
	}
	if (!items[14] && items.elementFactory) {
		items[14] = items.elementFactory(14,{"animation":"","isButton":true,"option":""});
	}
	if (items[14]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[14] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[14] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[14] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[14] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[14].x = -423.6;
		items[14].y = 221.9;
		items[14].rotation = -0.0686;
		if (items[14].scale) items[14].scale.x = 0.915;
		if (items[14].scale) items[14].scale.y = 0.930;
		if (items[14].onLayout) items[14].onLayout();
	}
	if (!items[15] && items.elementFactory) {
		items[15] = items.elementFactory(15,{"animation":"","isButton":true,"option":""});
	}
	if (items[15]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[15] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[15] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[15] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[15] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[15].x = 173.25;
		items[15].y = 168.4;
		items[15].rotation = 0.1962;
		if (items[15].scale) items[15].scale.x = 0.906;
		if (items[15].scale) items[15].scale.y = 0.921;
		if (items[15].onLayout) items[15].onLayout();
	}
	if (!items[16] && items.elementFactory) {
		items[16] = items.elementFactory(16,{"animation":"","isButton":true,"option":""});
	}
	if (items[16]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[16] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[16] as ICharlesDickensStoryLayout_dicBalloons1).animation = "";
		(items[16] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[16] as ICharlesDickensStoryLayout_dicBalloons1).option = "";
		items[16].x = -27.7;
		items[16].y = 323.95;
		items[16].rotation = 0.1444;
		if (items[16].scale) items[16].scale.x = 0.770;
		if (items[16].scale) items[16].scale.y = 0.782;
		if (items[16].onLayout) items[16].onLayout();
	}
	if (!items[17] && items.elementFactory) {
		items[17] = items.elementFactory(17,{"animation":"id=balloon","isButton":true,"option":"undefined"});
	}
	if (items[17]) {
		CharlesDickensStoryLayout_dicBalloons1.call(items[17] as ICharlesDickensStoryLayout_dicBalloons1);
		(items[17] as ICharlesDickensStoryLayout_dicBalloons1).animation = "id=balloon";
		(items[17] as ICharlesDickensStoryLayout_dicBalloons1).isButton = true;
		(items[17] as ICharlesDickensStoryLayout_dicBalloons1).option = "undefined";
		items[17].x = -241.5;
		items[17].y = 495.95;
		items[17].rotation = -0.0220;
		if (items[17].scale) items[17].scale.x = 0.800;
		if (items[17].scale) items[17].scale.y = 0.813;
		if (items[17].onLayout) items[17].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBalloons1(this: ICharlesDickensStoryLayout_dicBalloons1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBalloons.call(items[0] as ICharlesDickensStoryLayout_dicBalloons);
		items[0].x = -108.5;
		items[0].y = -131.5;
		items[0].width = 217.00;
		items[0].height = 263.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBalloons(this: ICharlesDickensStoryLayout_dicBalloons) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-balloons.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_slotChickens(this: ICharlesDickensStoryLayout_slotChickens) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens51.call(items[0] as ICharlesDickensStoryLayout_dicChickens51);
		(items[0] as ICharlesDickensStoryLayout_dicChickens51).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicChickens51).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicChickens51).option = "";
		items[0].x = 368.05;
		items[0].y = 83.8;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicChickens91.call(items[1] as ICharlesDickensStoryLayout_dicChickens91);
		(items[1] as ICharlesDickensStoryLayout_dicChickens91).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicChickens91).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicChickens91).option = "";
		items[1].x = 53.05;
		items[1].y = 72.45;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicChickens71.call(items[2] as ICharlesDickensStoryLayout_dicChickens71);
		(items[2] as ICharlesDickensStoryLayout_dicChickens71).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicChickens71).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicChickens71).option = "";
		items[2].x = -139.15;
		items[2].y = 77.55;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":""});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicChickens21.call(items[3] as ICharlesDickensStoryLayout_dicChickens21);
		(items[3] as ICharlesDickensStoryLayout_dicChickens21).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicChickens21).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicChickens21).option = "";
		items[3].x = -338.55;
		items[3].y = 99.75;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"","isButton":true,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicChickens31.call(items[4] as ICharlesDickensStoryLayout_dicChickens31);
		(items[4] as ICharlesDickensStoryLayout_dicChickens31).animation = "";
		(items[4] as ICharlesDickensStoryLayout_dicChickens31).isButton = true;
		(items[4] as ICharlesDickensStoryLayout_dicChickens31).option = "";
		items[4].x = -436.5;
		items[4].y = 172.05;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"","isButton":true,"option":""});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicChickens81.call(items[5] as ICharlesDickensStoryLayout_dicChickens81);
		(items[5] as ICharlesDickensStoryLayout_dicChickens81).animation = "";
		(items[5] as ICharlesDickensStoryLayout_dicChickens81).isButton = true;
		(items[5] as ICharlesDickensStoryLayout_dicChickens81).option = "";
		items[5].x = 222.05;
		items[5].y = 103.8;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"","isButton":true,"option":""});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicChickens11.call(items[6] as ICharlesDickensStoryLayout_dicChickens11);
		(items[6] as ICharlesDickensStoryLayout_dicChickens11).animation = "";
		(items[6] as ICharlesDickensStoryLayout_dicChickens11).isButton = true;
		(items[6] as ICharlesDickensStoryLayout_dicChickens11).option = "";
		items[6].x = -245.9;
		items[6].y = 190.5;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":true,"option":""});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_dicChickens41.call(items[7] as ICharlesDickensStoryLayout_dicChickens41);
		(items[7] as ICharlesDickensStoryLayout_dicChickens41).animation = "";
		(items[7] as ICharlesDickensStoryLayout_dicChickens41).isButton = true;
		(items[7] as ICharlesDickensStoryLayout_dicChickens41).option = "";
		items[7].x = 361.3;
		items[7].y = 145.95;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"","isButton":true,"option":""});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicChickens61.call(items[8] as ICharlesDickensStoryLayout_dicChickens61);
		(items[8] as ICharlesDickensStoryLayout_dicChickens61).animation = "";
		(items[8] as ICharlesDickensStoryLayout_dicChickens61).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicChickens61).option = "";
		items[8].x = 15.9;
		items[8].y = 190.6;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens51(this: ICharlesDickensStoryLayout_dicChickens51) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens5.call(items[0] as ICharlesDickensStoryLayout_dicChickens5);
		items[0].x = -118.5;
		items[0].y = -226;
		items[0].width = 237.00;
		items[0].height = 226.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens5(this: ICharlesDickensStoryLayout_dicChickens5) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-5.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens91(this: ICharlesDickensStoryLayout_dicChickens91) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens9.call(items[0] as ICharlesDickensStoryLayout_dicChickens9);
		items[0].x = -90.5;
		items[0].y = -263;
		items[0].width = 181.00;
		items[0].height = 263.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens9(this: ICharlesDickensStoryLayout_dicChickens9) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-9.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens71(this: ICharlesDickensStoryLayout_dicChickens71) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens7.call(items[0] as ICharlesDickensStoryLayout_dicChickens7);
		items[0].x = -87.5;
		items[0].y = -267;
		items[0].width = 175.00;
		items[0].height = 267.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens7(this: ICharlesDickensStoryLayout_dicChickens7) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-7.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens21(this: ICharlesDickensStoryLayout_dicChickens21) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens2.call(items[0] as ICharlesDickensStoryLayout_dicChickens2);
		items[0].x = -123;
		items[0].y = -258;
		items[0].width = 246.00;
		items[0].height = 258.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens2(this: ICharlesDickensStoryLayout_dicChickens2) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-2.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens31(this: ICharlesDickensStoryLayout_dicChickens31) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens3.call(items[0] as ICharlesDickensStoryLayout_dicChickens3);
		items[0].x = -50;
		items[0].y = -104;
		items[0].width = 100.00;
		items[0].height = 104.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens3(this: ICharlesDickensStoryLayout_dicChickens3) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-3.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens81(this: ICharlesDickensStoryLayout_dicChickens81) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens8.call(items[0] as ICharlesDickensStoryLayout_dicChickens8);
		items[0].x = -125.5;
		items[0].y = -263;
		items[0].width = 251.00;
		items[0].height = 263.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens8(this: ICharlesDickensStoryLayout_dicChickens8) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-8.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens11(this: ICharlesDickensStoryLayout_dicChickens11) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens1.call(items[0] as ICharlesDickensStoryLayout_dicChickens1);
		items[0].x = -107.5;
		items[0].y = -237;
		items[0].width = 215.00;
		items[0].height = 237.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens1(this: ICharlesDickensStoryLayout_dicChickens1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-1.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens41(this: ICharlesDickensStoryLayout_dicChickens41) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens4.call(items[0] as ICharlesDickensStoryLayout_dicChickens4);
		items[0].x = -118.5;
		items[0].y = -251;
		items[0].width = 237.00;
		items[0].height = 251.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens4(this: ICharlesDickensStoryLayout_dicChickens4) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-4.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicChickens61(this: ICharlesDickensStoryLayout_dicChickens61) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicChickens6.call(items[0] as ICharlesDickensStoryLayout_dicChickens6);
		items[0].x = -136.5;
		items[0].y = -259;
		items[0].width = 273.00;
		items[0].height = 259.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicChickens6(this: ICharlesDickensStoryLayout_dicChickens6) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-chickens-6.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicWorms1(this: ICharlesDickensStoryLayout_dicWorms1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicWorms.call(items[0] as ICharlesDickensStoryLayout_dicWorms);
		items[0].x = -503;
		items[0].y = -212;
		items[0].width = 1006.00;
		items[0].height = 212.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicWorms(this: ICharlesDickensStoryLayout_dicWorms) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-worms.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_slotLocationSeaRight(this: ICharlesDickensStoryLayout_slotLocationSeaRight) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSeaPlant3.call(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3);
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicSeaPlant3).option = "";
		items[0].x = 387.95;
		items[0].y = 903.6;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":""});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSeaFish2.call(items[1] as ICharlesDickensStoryLayout_dicSeaFish2);
		(items[1] as ICharlesDickensStoryLayout_dicSeaFish2).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicSeaFish2).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicSeaFish2).option = "";
		items[1].x = 181.25;
		items[1].y = 437;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":""});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSeaBubbles2.call(items[2] as ICharlesDickensStoryLayout_dicSeaBubbles2);
		(items[2] as ICharlesDickensStoryLayout_dicSeaBubbles2).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicSeaBubbles2).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicSeaBubbles2).option = "";
		items[2].x = 250;
		items[2].y = 214;
		items[2].width = 499.00;
		items[2].height = 427.00;
		if (items[2].onLayout) items[2].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBExcited1(this: ICharlesDickensStoryLayout_dicBExcited1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBExcited.call(items[0] as ICharlesDickensStoryLayout_dicBExcited);
		items[0].x = -188;
		items[0].y = -605;
		items[0].width = 376.00;
		items[0].height = 605.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBExcited(this: ICharlesDickensStoryLayout_dicBExcited) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-excited.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBPointing1(this: ICharlesDickensStoryLayout_dicBPointing1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBPointing.call(items[0] as ICharlesDickensStoryLayout_dicBPointing);
		items[0].x = -191.5;
		items[0].y = -598;
		items[0].width = 383.00;
		items[0].height = 598.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBPointing(this: ICharlesDickensStoryLayout_dicBPointing) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-pointing.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBConcerned1(this: ICharlesDickensStoryLayout_dicBConcerned1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBConcerned.call(items[0] as ICharlesDickensStoryLayout_dicBConcerned);
		items[0].x = -190;
		items[0].y = -606;
		items[0].width = 380.00;
		items[0].height = 606.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBConcerned(this: ICharlesDickensStoryLayout_dicBConcerned) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-concerned.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBScared1(this: ICharlesDickensStoryLayout_dicBScared1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBScared.call(items[0] as ICharlesDickensStoryLayout_dicBScared);
		items[0].x = -197.5;
		items[0].y = -680;
		items[0].width = 395.00;
		items[0].height = 680.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBScared(this: ICharlesDickensStoryLayout_dicBScared) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-scared.png", 0.000, 0.000);
	return this;
}
export function CharlesDickensStoryLayout_scene5Belt(this: ICharlesDickensStoryLayout_scene5Belt) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":false,"option":"sea"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_locationSea1.call(items[0] as ICharlesDickensStoryLayout_locationSea1);
		(items[0] as ICharlesDickensStoryLayout_locationSea1).animation = "";
		(items[0] as ICharlesDickensStoryLayout_locationSea1).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_locationSea1).option = "sea";
		items[0].x = 0;
		items[0].y = 0;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"static","isButton":false,"option":"space"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_locationSpace.call(items[1] as ICharlesDickensStoryLayout_locationSpace);
		(items[1] as ICharlesDickensStoryLayout_locationSpace).animation = "static";
		(items[1] as ICharlesDickensStoryLayout_locationSpace).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_locationSpace).option = "space";
		items[1].x = 0;
		items[1].y = 0;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"static","isButton":false,"option":"clouds"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_locationClouds.call(items[2] as ICharlesDickensStoryLayout_locationClouds);
		(items[2] as ICharlesDickensStoryLayout_locationClouds).animation = "static";
		(items[2] as ICharlesDickensStoryLayout_locationClouds).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_locationClouds).option = "clouds";
		items[2].x = 0;
		items[2].y = 0;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"static","isButton":false,"option":"baseballfield"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_locationStadium.call(items[3] as ICharlesDickensStoryLayout_locationStadium);
		(items[3] as ICharlesDickensStoryLayout_locationStadium).animation = "static";
		(items[3] as ICharlesDickensStoryLayout_locationStadium).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_locationStadium).option = "baseballfield";
		items[3].x = 1024;
		items[3].y = 1536;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_paperLayer.call(items[4] as ICharlesDickensStoryLayout_paperLayer);
		(items[4] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,undefined);
	}
	if (items[5]) {
		CharlesDickensStoryLayout_slotChair1.call(items[5] as ICharlesDickensStoryLayout_slotChair1);
		items[5].x = 0;
		items[5].y = 0;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"isPaperLayer":true});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_paperLayer.call(items[6] as ICharlesDickensStoryLayout_paperLayer);
		(items[6] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[6].x = 0;
		items[6].y = 0;
		items[6].width = 2048.00;
		items[6].height = 1536.00;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"","isButton":false,"option":"sea"});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_slotLocationSeaRight.call(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight);
		(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight).animation = "";
		(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight).isButton = false;
		(items[7] as ICharlesDickensStoryLayout_slotLocationSeaRight).option = "sea";
		items[7].x = 1445.05;
		items[7].y = 405;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch","isButton":true,"option":""});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicBAgast1.call(items[8] as ICharlesDickensStoryLayout_dicBAgast1);
		(items[8] as ICharlesDickensStoryLayout_dicBAgast1).animation = "squishStretch";
		(items[8] as ICharlesDickensStoryLayout_dicBAgast1).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicBAgast1).option = "";
		items[8].x = 414.45;
		items[8].y = 1254.15;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_slotChair1(this: ICharlesDickensStoryLayout_slotChair1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"static","isButton":true,"option":"popcorn"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicPopcorn12.call(items[0] as ICharlesDickensStoryLayout_dicPopcorn12);
		(items[0] as ICharlesDickensStoryLayout_dicPopcorn12).animation = "static";
		(items[0] as ICharlesDickensStoryLayout_dicPopcorn12).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicPopcorn12).option = "popcorn";
		items[0].x = 1204.95;
		items[0].y = 1254.85;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"static","isButton":false,"option":"balloons"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_slotBallons.call(items[1] as ICharlesDickensStoryLayout_slotBallons);
		(items[1] as ICharlesDickensStoryLayout_slotBallons).animation = "static";
		(items[1] as ICharlesDickensStoryLayout_slotBallons).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_slotBallons).option = "balloons";
		items[1].x = 1373.8;
		items[1].y = 670.8;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"static","isButton":false,"option":"chickens"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_slotChickens.call(items[2] as ICharlesDickensStoryLayout_slotChickens);
		(items[2] as ICharlesDickensStoryLayout_slotChickens).animation = "static";
		(items[2] as ICharlesDickensStoryLayout_slotChickens).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_slotChickens).option = "chickens";
		items[2].x = 1318.85;
		items[2].y = 1082.65;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"static","isButton":true,"option":"worms"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicWorms1.call(items[3] as ICharlesDickensStoryLayout_dicWorms1);
		(items[3] as ICharlesDickensStoryLayout_dicWorms1).animation = "static";
		(items[3] as ICharlesDickensStoryLayout_dicWorms1).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicWorms1).option = "worms";
		items[3].x = 1145.5;
		items[3].y = 1300.45;
		if (items[3].onLayout) items[3].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBAgast1(this: ICharlesDickensStoryLayout_dicBAgast1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBAgast.call(items[0] as ICharlesDickensStoryLayout_dicBAgast);
		items[0].x = -192;
		items[0].y = -606;
		items[0].width = 384.00;
		items[0].height = 606.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"tennisracket"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicTennisracket1.call(items[1] as ICharlesDickensStoryLayout_dicTennisracket1);
		(items[1] as ICharlesDickensStoryLayout_dicTennisracket1).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicTennisracket1).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicTennisracket1).option = "tennisracket";
		items[1].x = 309.4;
		items[1].y = -467.5;
		items[1].rotation = -0.0000;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":false,"option":"banana"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicBanana1.call(items[2] as ICharlesDickensStoryLayout_dicBanana1);
		(items[2] as ICharlesDickensStoryLayout_dicBanana1).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicBanana1).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicBanana1).option = "banana";
		items[2].x = 296.15;
		items[2].y = -276.8;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":false,"option":"lollipop"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicLollipop1.call(items[3] as ICharlesDickensStoryLayout_dicLollipop1);
		(items[3] as ICharlesDickensStoryLayout_dicLollipop1).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicLollipop1).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_dicLollipop1).option = "lollipop";
		items[3].x = 217.95;
		items[3].y = -416.85;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"","isButton":false,"option":"bowlingball"});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicBowlingball1.call(items[4] as ICharlesDickensStoryLayout_dicBowlingball1);
		(items[4] as ICharlesDickensStoryLayout_dicBowlingball1).animation = "";
		(items[4] as ICharlesDickensStoryLayout_dicBowlingball1).isButton = false;
		(items[4] as ICharlesDickensStoryLayout_dicBowlingball1).option = "bowlingball";
		items[4].x = 256;
		items[4].y = -312.7;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBAgast(this: ICharlesDickensStoryLayout_dicBAgast) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-agast.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicTennisracket1(this: ICharlesDickensStoryLayout_dicTennisracket1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicTennisracket.call(items[0] as ICharlesDickensStoryLayout_dicTennisracket);
		items[0].x = -205;
		items[0].y = -159.5;
		items[0].width = 365.00;
		items[0].height = 372.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicTennisracket(this: ICharlesDickensStoryLayout_dicTennisracket) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-tennisracket.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBanana1(this: ICharlesDickensStoryLayout_dicBanana1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBanana.call(items[0] as ICharlesDickensStoryLayout_dicBanana);
		items[0].x = -158.5;
		items[0].y = -142;
		items[0].width = 224.00;
		items[0].height = 233.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBanana(this: ICharlesDickensStoryLayout_dicBanana) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-banana.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicLollipop1(this: ICharlesDickensStoryLayout_dicLollipop1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicLollipop.call(items[0] as ICharlesDickensStoryLayout_dicLollipop);
		items[0].x = -122;
		items[0].y = -138;
		items[0].width = 288.00;
		items[0].height = 326.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicLollipop(this: ICharlesDickensStoryLayout_dicLollipop) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-lollipop.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBowlingball1(this: ICharlesDickensStoryLayout_dicBowlingball1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBowlingball.call(items[0] as ICharlesDickensStoryLayout_dicBowlingball);
		items[0].x = -135;
		items[0].y = -137.5;
		items[0].width = 270.00;
		items[0].height = 275.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBowlingball(this: ICharlesDickensStoryLayout_dicBowlingball) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-bowlingball.png", 0.000, 0.000);
	return this;
}
export function CharlesDickensStoryLayout_scene6End(this: ICharlesDickensStoryLayout_scene6End) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"children:squishStretch","isButton":false,"option":"home"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBed.call(items[0] as ICharlesDickensStoryLayout_dicBed);
		(items[0] as ICharlesDickensStoryLayout_dicBed).animation = "children:squishStretch";
		(items[0] as ICharlesDickensStoryLayout_dicBed).isButton = false;
		(items[0] as ICharlesDickensStoryLayout_dicBed).option = "home";
		items[0].x = 363.85;
		items[0].y = 482.4;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":false,"option":"circus"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicCircus.call(items[1] as ICharlesDickensStoryLayout_dicCircus);
		(items[1] as ICharlesDickensStoryLayout_dicCircus).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicCircus).isButton = false;
		(items[1] as ICharlesDickensStoryLayout_dicCircus).option = "circus";
		items[1].x = 673.95;
		items[1].y = 72.25;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"children:squishStretch","isButton":false,"option":"museum"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicMuseum.call(items[2] as ICharlesDickensStoryLayout_dicMuseum);
		(items[2] as ICharlesDickensStoryLayout_dicMuseum).animation = "children:squishStretch";
		(items[2] as ICharlesDickensStoryLayout_dicMuseum).isButton = false;
		(items[2] as ICharlesDickensStoryLayout_dicMuseum).option = "museum";
		items[2].x = 375.55;
		items[2].y = 474.6;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"children:squishStretch","isButton":false,"option":"butterfly"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_slotButterfly.call(items[3] as ICharlesDickensStoryLayout_slotButterfly);
		(items[3] as ICharlesDickensStoryLayout_slotButterfly).animation = "children:squishStretch";
		(items[3] as ICharlesDickensStoryLayout_slotButterfly).isButton = false;
		(items[3] as ICharlesDickensStoryLayout_slotButterfly).option = "butterfly";
		items[3].x = 1228.95;
		items[3].y = 1039.6;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"isPaperLayer":true});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_paperLayer.call(items[4] as ICharlesDickensStoryLayout_paperLayer);
		(items[4] as ICharlesDickensStoryLayout_paperLayer).isPaperLayer = true;
		items[4].x = 0;
		items[4].y = 0;
		items[4].width = 2048.00;
		items[4].height = 1536.00;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch","isButton":true,"option":"chickens circus"});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicSmallchicken1.call(items[5] as ICharlesDickensStoryLayout_dicSmallchicken1);
		(items[5] as ICharlesDickensStoryLayout_dicSmallchicken1).animation = "squishStretch";
		(items[5] as ICharlesDickensStoryLayout_dicSmallchicken1).isButton = true;
		(items[5] as ICharlesDickensStoryLayout_dicSmallchicken1).option = "chickens circus";
		items[5].x = 1816.45;
		items[5].y = 1039.35;
		if (items[5].scale) items[5].scale.x = -1.000;
		if (items[5].scale) items[5].scale.y = 1.000;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch","isButton":true,"option":"balloons circus"});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicSmallballoon1.call(items[6] as ICharlesDickensStoryLayout_dicSmallballoon1);
		(items[6] as ICharlesDickensStoryLayout_dicSmallballoon1).animation = "squishStretch";
		(items[6] as ICharlesDickensStoryLayout_dicSmallballoon1).isButton = true;
		(items[6] as ICharlesDickensStoryLayout_dicSmallballoon1).option = "balloons circus";
		items[6].x = 1764.75;
		items[6].y = 1041;
		if (items[6].scale) items[6].scale.x = -1.000;
		if (items[6].scale) items[6].scale.y = 1.000;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch","isButton":true,"option":"worms circus"});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_dicSmallworms1.call(items[7] as ICharlesDickensStoryLayout_dicSmallworms1);
		(items[7] as ICharlesDickensStoryLayout_dicSmallworms1).animation = "squishStretch";
		(items[7] as ICharlesDickensStoryLayout_dicSmallworms1).isButton = true;
		(items[7] as ICharlesDickensStoryLayout_dicSmallworms1).option = "worms circus";
		items[7].x = 1757.25;
		items[7].y = 1034.85;
		if (items[7].scale) items[7].scale.x = -1.000;
		if (items[7].scale) items[7].scale.y = 1.000;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch","isButton":true,"option":"popcorn circus"});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicSmallpopcorn1.call(items[8] as ICharlesDickensStoryLayout_dicSmallpopcorn1);
		(items[8] as ICharlesDickensStoryLayout_dicSmallpopcorn1).animation = "squishStretch";
		(items[8] as ICharlesDickensStoryLayout_dicSmallpopcorn1).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicSmallpopcorn1).option = "popcorn circus";
		items[8].x = 1758.25;
		items[8].y = 1039.7;
		if (items[8].scale) items[8].scale.x = -1.000;
		if (items[8].scale) items[8].scale.y = 1.000;
		if (items[8].onLayout) items[8].onLayout();
	}
	if (!items[9] && items.elementFactory) {
		items[9] = items.elementFactory(9,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"home"});
	}
	if (items[9]) {
		CharlesDickensStoryLayout_dicBHome1.call(items[9] as ICharlesDickensStoryLayout_dicBHome1);
		(items[9] as ICharlesDickensStoryLayout_dicBHome1).animation = "squishStretch appear delay=0.2";
		(items[9] as ICharlesDickensStoryLayout_dicBHome1).isButton = true;
		(items[9] as ICharlesDickensStoryLayout_dicBHome1).option = "home";
		items[9].x = 935.4;
		items[9].y = 1144.45;
		if (items[9].onLayout) items[9].onLayout();
	}
	if (!items[10] && items.elementFactory) {
		items[10] = items.elementFactory(10,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"circus"});
	}
	if (items[10]) {
		CharlesDickensStoryLayout_dicBCircus1.call(items[10] as ICharlesDickensStoryLayout_dicBCircus1);
		(items[10] as ICharlesDickensStoryLayout_dicBCircus1).animation = "squishStretch appear delay=0.2";
		(items[10] as ICharlesDickensStoryLayout_dicBCircus1).isButton = true;
		(items[10] as ICharlesDickensStoryLayout_dicBCircus1).option = "circus";
		items[10].x = 416.2;
		items[10].y = 1086.4;
		if (items[10].onLayout) items[10].onLayout();
	}
	if (!items[11] && items.elementFactory) {
		items[11] = items.elementFactory(11,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"museum"});
	}
	if (items[11]) {
		CharlesDickensStoryLayout_dicBMuseum1.call(items[11] as ICharlesDickensStoryLayout_dicBMuseum1);
		(items[11] as ICharlesDickensStoryLayout_dicBMuseum1).animation = "squishStretch appear delay=0.2";
		(items[11] as ICharlesDickensStoryLayout_dicBMuseum1).isButton = true;
		(items[11] as ICharlesDickensStoryLayout_dicBMuseum1).option = "museum";
		items[11].x = 982.3;
		items[11].y = 874.65;
		if (items[11].onLayout) items[11].onLayout();
	}
	if (!items[12] && items.elementFactory) {
		items[12] = items.elementFactory(12,{"animation":"squishStretch appear delay=0.2","isButton":true,"option":"butterfly"});
	}
	if (items[12]) {
		CharlesDickensStoryLayout_dicBButterfly1.call(items[12] as ICharlesDickensStoryLayout_dicBButterfly1);
		(items[12] as ICharlesDickensStoryLayout_dicBButterfly1).animation = "squishStretch appear delay=0.2";
		(items[12] as ICharlesDickensStoryLayout_dicBButterfly1).isButton = true;
		(items[12] as ICharlesDickensStoryLayout_dicBButterfly1).option = "butterfly";
		items[12].x = 454;
		items[12].y = 1115.45;
		if (items[12].onLayout) items[12].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBed(this: ICharlesDickensStoryLayout_dicBed) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"chickens"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallchicken1.call(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1);
		(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1).option = "chickens";
		items[0].x = -3.25;
		items[0].y = 533.7;
		if (items[0].scale) items[0].scale.x = -1.000;
		if (items[0].scale) items[0].scale.y = 1.000;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"balloons"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSmallballoon1.call(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1);
		(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1).option = "balloons";
		items[1].x = -2.15;
		items[1].y = 534.3;
		if (items[1].scale) items[1].scale.x = -1.000;
		if (items[1].scale) items[1].scale.y = 1.000;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"popcorn"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSmallpopcorn1.call(items[2] as ICharlesDickensStoryLayout_dicSmallpopcorn1);
		(items[2] as ICharlesDickensStoryLayout_dicSmallpopcorn1).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicSmallpopcorn1).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicSmallpopcorn1).option = "popcorn";
		items[2].x = -63.75;
		items[2].y = 548.3;
		if (items[2].scale) items[2].scale.x = -1.000;
		if (items[2].scale) items[2].scale.y = 1.000;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"worms"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicSmallworms1.call(items[3] as ICharlesDickensStoryLayout_dicSmallworms1);
		(items[3] as ICharlesDickensStoryLayout_dicSmallworms1).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicSmallworms1).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicSmallworms1).option = "worms";
		items[3].x = -21.65;
		items[3].y = 536.6;
		if (items[3].scale) items[3].scale.x = -1.000;
		if (items[3].scale) items[3].scale.y = 1.000;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"","isButton":true,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicBed2.call(items[4] as ICharlesDickensStoryLayout_dicBed2);
		(items[4] as ICharlesDickensStoryLayout_dicBed2).animation = "";
		(items[4] as ICharlesDickensStoryLayout_dicBed2).isButton = true;
		(items[4] as ICharlesDickensStoryLayout_dicBed2).option = "";
		items[4].x = 657;
		items[4].y = 560;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSmallchicken1(this: ICharlesDickensStoryLayout_dicSmallchicken1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallchicken.call(items[0] as ICharlesDickensStoryLayout_dicSmallchicken);
		items[0].x = -70.5;
		items[0].y = -147;
		items[0].width = 141.00;
		items[0].height = 147.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSmallchicken(this: ICharlesDickensStoryLayout_dicSmallchicken) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallchicken.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicSmallballoon1(this: ICharlesDickensStoryLayout_dicSmallballoon1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallballoon.call(items[0] as ICharlesDickensStoryLayout_dicSmallballoon);
		items[0].x = -69;
		items[0].y = -130;
		items[0].width = 138.00;
		items[0].height = 130.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSmallballoon(this: ICharlesDickensStoryLayout_dicSmallballoon) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallballoon.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicSmallpopcorn1(this: ICharlesDickensStoryLayout_dicSmallpopcorn1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallpopcorn.call(items[0] as ICharlesDickensStoryLayout_dicSmallpopcorn);
		items[0].x = -93.5;
		items[0].y = -76;
		items[0].width = 187.00;
		items[0].height = 76.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSmallpopcorn(this: ICharlesDickensStoryLayout_dicSmallpopcorn) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallpopcorn.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicSmallworms1(this: ICharlesDickensStoryLayout_dicSmallworms1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallworms.call(items[0] as ICharlesDickensStoryLayout_dicSmallworms);
		items[0].x = -104;
		items[0].y = -69;
		items[0].width = 208.00;
		items[0].height = 69.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicSmallworms(this: ICharlesDickensStoryLayout_dicSmallworms) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-smallworms.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicCircus(this: ICharlesDickensStoryLayout_dicCircus) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"squishStretch","isButton":true,"option":""});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicCircus2.call(items[0] as ICharlesDickensStoryLayout_dicCircus2);
		(items[0] as ICharlesDickensStoryLayout_dicCircus2).animation = "squishStretch";
		(items[0] as ICharlesDickensStoryLayout_dicCircus2).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicCircus2).option = "";
		items[0].x = 672.5;
		items[0].y = 966;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicCircus2(this: ICharlesDickensStoryLayout_dicCircus2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicCircus1.call(items[0] as ICharlesDickensStoryLayout_dicCircus1);
		items[0].x = 0.5;
		items[0].y = -483;
		items[0].width = 1345.00;
		items[0].height = 966.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicCircus1(this: ICharlesDickensStoryLayout_dicCircus1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-circus.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicMuseum(this: ICharlesDickensStoryLayout_dicMuseum) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"popcorn"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallpopcorn1.call(items[0] as ICharlesDickensStoryLayout_dicSmallpopcorn1);
		(items[0] as ICharlesDickensStoryLayout_dicSmallpopcorn1).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicSmallpopcorn1).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicSmallpopcorn1).option = "popcorn";
		items[0].x = 0.8;
		items[0].y = 456.25;
		if (items[0].scale) items[0].scale.x = -1.000;
		if (items[0].scale) items[0].scale.y = 1.000;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"chickens"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSmallchicken1.call(items[1] as ICharlesDickensStoryLayout_dicSmallchicken1);
		(items[1] as ICharlesDickensStoryLayout_dicSmallchicken1).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicSmallchicken1).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicSmallchicken1).option = "chickens";
		items[1].x = 34.8;
		items[1].y = 465.2;
		if (items[1].scale) items[1].scale.x = -1.000;
		if (items[1].scale) items[1].scale.y = 1.000;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"balloons"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSmallballoon1.call(items[2] as ICharlesDickensStoryLayout_dicSmallballoon1);
		(items[2] as ICharlesDickensStoryLayout_dicSmallballoon1).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicSmallballoon1).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicSmallballoon1).option = "balloons";
		items[2].x = 34.8;
		items[2].y = 466.15;
		if (items[2].scale) items[2].scale.x = -1.000;
		if (items[2].scale) items[2].scale.y = 1.000;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"worms"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicSmallworms1.call(items[3] as ICharlesDickensStoryLayout_dicSmallworms1);
		(items[3] as ICharlesDickensStoryLayout_dicSmallworms1).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicSmallworms1).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicSmallworms1).option = "worms";
		items[3].x = 25.15;
		items[3].y = 452.45;
		if (items[3].scale) items[3].scale.x = -1.000;
		if (items[3].scale) items[3].scale.y = 1.000;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"","isButton":true,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicMuseum2.call(items[4] as ICharlesDickensStoryLayout_dicMuseum2);
		(items[4] as ICharlesDickensStoryLayout_dicMuseum2).animation = "";
		(items[4] as ICharlesDickensStoryLayout_dicMuseum2).isButton = true;
		(items[4] as ICharlesDickensStoryLayout_dicMuseum2).option = "";
		items[4].x = 667.5;
		items[4].y = 605;
		if (items[4].onLayout) items[4].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicMuseum2(this: ICharlesDickensStoryLayout_dicMuseum2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicMuseum1.call(items[0] as ICharlesDickensStoryLayout_dicMuseum1);
		items[0].x = 0;
		items[0].y = -302.5;
		items[0].width = 1335.00;
		items[0].height = 605.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicMuseum1(this: ICharlesDickensStoryLayout_dicMuseum1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-museum.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_slotButterfly(this: ICharlesDickensStoryLayout_slotButterfly) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,{"animation":"","isButton":true,"option":"chickens"});
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicSmallchicken1.call(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1);
		(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1).animation = "";
		(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1).isButton = true;
		(items[0] as ICharlesDickensStoryLayout_dicSmallchicken1).option = "chickens";
		items[0].x = 543.7;
		items[0].y = -37.3;
		if (items[0].onLayout) items[0].onLayout();
	}
	if (!items[1] && items.elementFactory) {
		items[1] = items.elementFactory(1,{"animation":"","isButton":true,"option":"balloons"});
	}
	if (items[1]) {
		CharlesDickensStoryLayout_dicSmallballoon1.call(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1);
		(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1).animation = "";
		(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1).isButton = true;
		(items[1] as ICharlesDickensStoryLayout_dicSmallballoon1).option = "balloons";
		items[1].x = 542.3;
		items[1].y = -37.3;
		if (items[1].onLayout) items[1].onLayout();
	}
	if (!items[2] && items.elementFactory) {
		items[2] = items.elementFactory(2,{"animation":"","isButton":true,"option":"worms"});
	}
	if (items[2]) {
		CharlesDickensStoryLayout_dicSmallworms1.call(items[2] as ICharlesDickensStoryLayout_dicSmallworms1);
		(items[2] as ICharlesDickensStoryLayout_dicSmallworms1).animation = "";
		(items[2] as ICharlesDickensStoryLayout_dicSmallworms1).isButton = true;
		(items[2] as ICharlesDickensStoryLayout_dicSmallworms1).option = "worms";
		items[2].x = 582.9;
		items[2].y = -48.6;
		if (items[2].onLayout) items[2].onLayout();
	}
	if (!items[3] && items.elementFactory) {
		items[3] = items.elementFactory(3,{"animation":"","isButton":true,"option":"popcorn"});
	}
	if (items[3]) {
		CharlesDickensStoryLayout_dicSmallpopcorn1.call(items[3] as ICharlesDickensStoryLayout_dicSmallpopcorn1);
		(items[3] as ICharlesDickensStoryLayout_dicSmallpopcorn1).animation = "";
		(items[3] as ICharlesDickensStoryLayout_dicSmallpopcorn1).isButton = true;
		(items[3] as ICharlesDickensStoryLayout_dicSmallpopcorn1).option = "popcorn";
		items[3].x = 592.15;
		items[3].y = -46.5;
		if (items[3].onLayout) items[3].onLayout();
	}
	if (!items[4] && items.elementFactory) {
		items[4] = items.elementFactory(4,{"animation":"","isButton":true,"option":""});
	}
	if (items[4]) {
		CharlesDickensStoryLayout_dicButterflyBack.call(items[4] as ICharlesDickensStoryLayout_dicButterflyBack);
		(items[4] as ICharlesDickensStoryLayout_dicButterflyBack).animation = "";
		(items[4] as ICharlesDickensStoryLayout_dicButterflyBack).isButton = true;
		(items[4] as ICharlesDickensStoryLayout_dicButterflyBack).option = "";
		items[4].x = 0;
		items[4].y = 0;
		if (items[4].onLayout) items[4].onLayout();
	}
	if (!items[5] && items.elementFactory) {
		items[5] = items.elementFactory(5,{"animation":"squishStretch appear delay=0.4","isButton":true,"option":""});
	}
	if (items[5]) {
		CharlesDickensStoryLayout_dicButterfly3.call(items[5] as ICharlesDickensStoryLayout_dicButterfly3);
		(items[5] as ICharlesDickensStoryLayout_dicButterfly3).animation = "squishStretch appear delay=0.4";
		(items[5] as ICharlesDickensStoryLayout_dicButterfly3).isButton = true;
		(items[5] as ICharlesDickensStoryLayout_dicButterfly3).option = "";
		items[5].x = -992.8;
		items[5].y = -839.8;
		if (items[5].onLayout) items[5].onLayout();
	}
	if (!items[6] && items.elementFactory) {
		items[6] = items.elementFactory(6,{"animation":"squishStretch appear delay=0.5","isButton":true,"option":""});
	}
	if (items[6]) {
		CharlesDickensStoryLayout_dicButterfly2.call(items[6] as ICharlesDickensStoryLayout_dicButterfly2);
		(items[6] as ICharlesDickensStoryLayout_dicButterfly2).animation = "squishStretch appear delay=0.5";
		(items[6] as ICharlesDickensStoryLayout_dicButterfly2).isButton = true;
		(items[6] as ICharlesDickensStoryLayout_dicButterfly2).option = "";
		items[6].x = 344.7;
		items[6].y = -765.35;
		if (items[6].onLayout) items[6].onLayout();
	}
	if (!items[7] && items.elementFactory) {
		items[7] = items.elementFactory(7,{"animation":"squishStretch appear delay=0.8","isButton":true,"option":""});
	}
	if (items[7]) {
		CharlesDickensStoryLayout_dicButterfly1.call(items[7] as ICharlesDickensStoryLayout_dicButterfly1);
		(items[7] as ICharlesDickensStoryLayout_dicButterfly1).animation = "squishStretch appear delay=0.8";
		(items[7] as ICharlesDickensStoryLayout_dicButterfly1).isButton = true;
		(items[7] as ICharlesDickensStoryLayout_dicButterfly1).option = "";
		items[7].x = -280.95;
		items[7].y = -840.8;
		if (items[7].onLayout) items[7].onLayout();
	}
	if (!items[8] && items.elementFactory) {
		items[8] = items.elementFactory(8,{"animation":"squishStretch appear delay=0.6","isButton":true,"option":""});
	}
	if (items[8]) {
		CharlesDickensStoryLayout_dicButterflyFront.call(items[8] as ICharlesDickensStoryLayout_dicButterflyFront);
		(items[8] as ICharlesDickensStoryLayout_dicButterflyFront).animation = "squishStretch appear delay=0.6";
		(items[8] as ICharlesDickensStoryLayout_dicButterflyFront).isButton = true;
		(items[8] as ICharlesDickensStoryLayout_dicButterflyFront).option = "";
		items[8].x = 148.7;
		items[8].y = -485.45;
		if (items[8].onLayout) items[8].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicButterflyBack(this: ICharlesDickensStoryLayout_dicButterflyBack) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicButterflyBack1.call(items[0] as ICharlesDickensStoryLayout_dicButterflyBack1);
		items[0].x = 0;
		items[0].y = -365;
		items[0].width = 1185.00;
		items[0].height = 730.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicButterflyBack1(this: ICharlesDickensStoryLayout_dicButterflyBack1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-back.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicButterfly3(this: ICharlesDickensStoryLayout_dicButterfly3) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicButterfly31.call(items[0] as ICharlesDickensStoryLayout_dicButterfly31);
		items[0].x = 0;
		items[0].y = 0;
		items[0].width = 170.00;
		items[0].height = 106.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicButterfly31(this: ICharlesDickensStoryLayout_dicButterfly31) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-y.png", 0.500, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicButterfly2(this: ICharlesDickensStoryLayout_dicButterfly2) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicButterfly21.call(items[0] as ICharlesDickensStoryLayout_dicButterfly21);
		items[0].x = 0.5;
		items[0].y = 0;
		items[0].width = 181.00;
		items[0].height = 154.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicButterfly21(this: ICharlesDickensStoryLayout_dicButterfly21) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-r.png", 0.503, 0.500);
	return this;
}
function CharlesDickensStoryLayout_dicButterfly1(this: ICharlesDickensStoryLayout_dicButterfly1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicButterfly11.call(items[0] as ICharlesDickensStoryLayout_dicButterfly11);
		items[0].x = 0.5;
		items[0].y = 0.5;
		items[0].width = 125.00;
		items[0].height = 109.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicButterfly11(this: ICharlesDickensStoryLayout_dicButterfly11) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-b.png", 0.504, 0.505);
	return this;
}
function CharlesDickensStoryLayout_dicButterflyFront(this: ICharlesDickensStoryLayout_dicButterflyFront) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicButterflyFront1.call(items[0] as ICharlesDickensStoryLayout_dicButterflyFront1);
		items[0].x = 66;
		items[0].y = -1;
		items[0].width = 135.00;
		items[0].height = 105.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicButterflyFront1(this: ICharlesDickensStoryLayout_dicButterflyFront1) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-butterfly-front.png", 0.989, 0.990);
	return this;
}
function CharlesDickensStoryLayout_dicBHome1(this: ICharlesDickensStoryLayout_dicBHome1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBHome.call(items[0] as ICharlesDickensStoryLayout_dicBHome);
		items[0].x = -260;
		items[0].y = -404;
		items[0].width = 520.00;
		items[0].height = 404.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBHome(this: ICharlesDickensStoryLayout_dicBHome) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-home.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBCircus1(this: ICharlesDickensStoryLayout_dicBCircus1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBCircus.call(items[0] as ICharlesDickensStoryLayout_dicBCircus);
		items[0].x = -212;
		items[0].y = -595;
		items[0].width = 424.00;
		items[0].height = 595.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBCircus(this: ICharlesDickensStoryLayout_dicBCircus) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-circus.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBMuseum1(this: ICharlesDickensStoryLayout_dicBMuseum1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBMuseum.call(items[0] as ICharlesDickensStoryLayout_dicBMuseum);
		items[0].x = -181;
		items[0].y = -462.85;
		items[0].width = 362.00;
		items[0].height = 558.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBMuseum(this: ICharlesDickensStoryLayout_dicBMuseum) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-museum.png", 0.000, 0.000);
	return this;
}
function CharlesDickensStoryLayout_dicBButterfly1(this: ICharlesDickensStoryLayout_dicBButterfly1) {
	const items = this.items;
	if (!items[0] && items.elementFactory) {
		items[0] = items.elementFactory(0,undefined);
	}
	if (items[0]) {
		CharlesDickensStoryLayout_dicBButterfly.call(items[0] as ICharlesDickensStoryLayout_dicBButterfly);
		items[0].x = -189;
		items[0].y = -724;
		items[0].width = 378.00;
		items[0].height = 724.00;
		if (items[0].onLayout) items[0].onLayout();
	}
	return this;
}
function CharlesDickensStoryLayout_dicBButterfly(this: ICharlesDickensStoryLayout_dicBButterfly) {
	if (this.setLayoutTexture) this.setLayoutTexture("dic-b-butterfly.png", 0.000, 0.000);
	return this;
}
interface ICharlesDickensStoryLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ICharlesDickensStoryLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ICharlesDickensStoryLayoutSprite extends ICharlesDickensStoryLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ICharlesDickensStoryLayoutText extends ICharlesDickensStoryLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ICharlesDickensStoryLayoutPolygon extends Array<number> {
}
interface ICharlesDickensStoryLayout {
	readonly scene1Start: ICharlesDickensStoryLayout_scene1Start;
	readonly scene2Imagination: ICharlesDickensStoryLayout_scene2Imagination;
	readonly scene3Location: ICharlesDickensStoryLayout_scene3Location;
	readonly scene4Chair: ICharlesDickensStoryLayout_scene4Chair;
	readonly scene5Belt: ICharlesDickensStoryLayout_scene5Belt;
	readonly scene6End: ICharlesDickensStoryLayout_scene6End;
}
interface ICharlesDickensStoryLayout_scene1Start extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_slotBradCouch|ICharlesDickensStoryLayout_slotBradBlanket|ICharlesDickensStoryLayout_slotBradBed|ICharlesDickensStoryLayout_slotBradBeanBag>;
}
interface ICharlesDickensStoryLayout_slotBradCouch extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicCouch|ICharlesDickensStoryLayout_dicBLaying>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicCouch extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBLaying extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_slotBradBlanket extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBlanket|ICharlesDickensStoryLayout_dicBLaying>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBlanket extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_slotBradBed extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBed2|ICharlesDickensStoryLayout_dicBLaying>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBed2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBed1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBed1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_slotBradBeanBag extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBeanbag|ICharlesDickensStoryLayout_dicBLaying>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBeanbag extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_scene2Imagination extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicWhale2|ICharlesDickensStoryLayout_dicSpaceship2|ICharlesDickensStoryLayout_dicCastle2|ICharlesDickensStoryLayout_dicAirplane2|ICharlesDickensStoryLayout_paperLayer|ICharlesDickensStoryLayout_slotBradConfused>;
}
interface ICharlesDickensStoryLayout_dicWhale2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicWhale1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicWhale1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicSpaceship2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSpaceship1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSpaceship1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicCastle2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicCastle1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicCastle1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicAirplane2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicAirplane1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicAirplane1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_paperLayer extends ICharlesDickensStoryLayoutContainer {
	isPaperLayer: boolean;
}
interface ICharlesDickensStoryLayout_slotBradConfused extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBSittingconfused>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBSittingconfused extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_scene3Location extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicWhale|ICharlesDickensStoryLayout_dicSpaceship|ICharlesDickensStoryLayout_dicCastle|ICharlesDickensStoryLayout_dicAirplane|ICharlesDickensStoryLayout_locationSea|ICharlesDickensStoryLayout_locationSpace|ICharlesDickensStoryLayout_locationClouds|ICharlesDickensStoryLayout_locationStadium|ICharlesDickensStoryLayout_paperLayer|ICharlesDickensStoryLayout_dicBSea1|ICharlesDickensStoryLayout_dicSeaBubbles3|ICharlesDickensStoryLayout_slotBradSpace|ICharlesDickensStoryLayout_dicBFlying1|ICharlesDickensStoryLayout_dicBBaseball1>;
}
interface ICharlesDickensStoryLayout_dicWhale extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicWhale1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSpaceship extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSpaceship1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicCastle extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicCastle1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicAirplane extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicAirplane1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_locationSea extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSeaPlant3|ICharlesDickensStoryLayout_dicSeaPlant2|ICharlesDickensStoryLayout_dicSeaPlant1|ICharlesDickensStoryLayout_dicSeaFish2|ICharlesDickensStoryLayout_dicSeaFish1|ICharlesDickensStoryLayout_dicSeaBubbles2|ICharlesDickensStoryLayout_dicSeaBubbles1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaPlant3 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSeaPlant31>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaPlant31 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicSeaPlant2 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaPlant1 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaFish2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSeaFish21>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaFish21 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicSeaFish1 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaBubbles2 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaBubbles1 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_locationSpace extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSpacePlanet3|ICharlesDickensStoryLayout_dicSpaceSatellite|ICharlesDickensStoryLayout_dicSpacePlanet4|ICharlesDickensStoryLayout_dicSpacePlanet2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSpacePlanet3 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSpaceSatellite extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSpacePlanet4 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSpacePlanet2 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_locationClouds extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicCloudsFront|ICharlesDickensStoryLayout_dicCloud3|ICharlesDickensStoryLayout_dicCloud2|ICharlesDickensStoryLayout_dicCloud1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicCloudsFront extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicCloud3 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicCloud2 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicCloud1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_locationStadium extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBaseballField|ICharlesDickensStoryLayout_dicBaseballLights|ICharlesDickensStoryLayout_dicBaseballBaseball|ICharlesDickensStoryLayout_dicBaseballBat>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBaseballField extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBaseballLights extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBaseballBaseball extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBaseballBat extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBSea1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBSea>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBSea extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaBubbles3 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSeaBubbles31>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSeaBubbles31 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_slotBradSpace extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBSpace>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBSpace extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBFlying1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBFlying>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBFlying extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBBaseball1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBBaseball>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBBaseball extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_scene4Chair extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_locationSea1|ICharlesDickensStoryLayout_locationSpace|ICharlesDickensStoryLayout_locationClouds|ICharlesDickensStoryLayout_locationStadium|ICharlesDickensStoryLayout_paperLayer|ICharlesDickensStoryLayout_slotChair|ICharlesDickensStoryLayout_slotLocationSeaRight|ICharlesDickensStoryLayout_dicBExcited1|ICharlesDickensStoryLayout_dicBPointing1|ICharlesDickensStoryLayout_dicBConcerned1|ICharlesDickensStoryLayout_dicBScared1>;
}
interface ICharlesDickensStoryLayout_locationSea1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSeaPlant2|ICharlesDickensStoryLayout_dicSeaPlant1|ICharlesDickensStoryLayout_dicSeaFish1|ICharlesDickensStoryLayout_dicSeaBubbles1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_slotChair extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicPopcorn12|ICharlesDickensStoryLayout_slotBallons|ICharlesDickensStoryLayout_slotChickens|ICharlesDickensStoryLayout_dicWorms1>;
}
interface ICharlesDickensStoryLayout_dicPopcorn12 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicPopcorn|ICharlesDickensStoryLayout_dicPopcorn1|ICharlesDickensStoryLayout_dicPopcorn2|ICharlesDickensStoryLayout_dicPopcorn3|ICharlesDickensStoryLayout_dicPopcorn4>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicPopcorn extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicPopcorn1 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicPopcorn2 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicPopcorn3 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicPopcorn4 extends ICharlesDickensStoryLayoutSprite {
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_slotBallons extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBalloons1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBalloons1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBalloons>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBalloons extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_slotChickens extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens51|ICharlesDickensStoryLayout_dicChickens91|ICharlesDickensStoryLayout_dicChickens71|ICharlesDickensStoryLayout_dicChickens21|ICharlesDickensStoryLayout_dicChickens31|ICharlesDickensStoryLayout_dicChickens81|ICharlesDickensStoryLayout_dicChickens11|ICharlesDickensStoryLayout_dicChickens41|ICharlesDickensStoryLayout_dicChickens61>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens51 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens5>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens5 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens91 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens9>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens9 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens71 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens7>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens7 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens21 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens2 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens31 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens3>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens3 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens81 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens8>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens8 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens11 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens41 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens4>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens4 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicChickens61 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicChickens6>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicChickens6 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicWorms1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicWorms>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicWorms extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_slotLocationSeaRight extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSeaPlant3|ICharlesDickensStoryLayout_dicSeaFish2|ICharlesDickensStoryLayout_dicSeaBubbles2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBExcited1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBExcited>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBExcited extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBPointing1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBPointing>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBPointing extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBConcerned1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBConcerned>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBConcerned extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBScared1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBScared>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBScared extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_scene5Belt extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_locationSea1|ICharlesDickensStoryLayout_locationSpace|ICharlesDickensStoryLayout_locationClouds|ICharlesDickensStoryLayout_locationStadium|ICharlesDickensStoryLayout_paperLayer|ICharlesDickensStoryLayout_slotChair1|ICharlesDickensStoryLayout_slotLocationSeaRight|ICharlesDickensStoryLayout_dicBAgast1>;
}
interface ICharlesDickensStoryLayout_slotChair1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicPopcorn12|ICharlesDickensStoryLayout_slotBallons|ICharlesDickensStoryLayout_slotChickens|ICharlesDickensStoryLayout_dicWorms1>;
}
interface ICharlesDickensStoryLayout_dicBAgast1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBAgast|ICharlesDickensStoryLayout_dicTennisracket1|ICharlesDickensStoryLayout_dicBanana1|ICharlesDickensStoryLayout_dicLollipop1|ICharlesDickensStoryLayout_dicBowlingball1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBAgast extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicTennisracket1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicTennisracket>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicTennisracket extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBanana1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBanana>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBanana extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicLollipop1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicLollipop>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicLollipop extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBowlingball1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBowlingball>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBowlingball extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_scene6End extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBed|ICharlesDickensStoryLayout_dicCircus|ICharlesDickensStoryLayout_dicMuseum|ICharlesDickensStoryLayout_slotButterfly|ICharlesDickensStoryLayout_paperLayer|ICharlesDickensStoryLayout_dicSmallchicken1|ICharlesDickensStoryLayout_dicSmallballoon1|ICharlesDickensStoryLayout_dicSmallworms1|ICharlesDickensStoryLayout_dicSmallpopcorn1|ICharlesDickensStoryLayout_dicBHome1|ICharlesDickensStoryLayout_dicBCircus1|ICharlesDickensStoryLayout_dicBMuseum1|ICharlesDickensStoryLayout_dicBButterfly1>;
}
interface ICharlesDickensStoryLayout_dicBed extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallchicken1|ICharlesDickensStoryLayout_dicSmallballoon1|ICharlesDickensStoryLayout_dicSmallpopcorn1|ICharlesDickensStoryLayout_dicSmallworms1|ICharlesDickensStoryLayout_dicBed2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSmallchicken1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallchicken>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSmallchicken extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicSmallballoon1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallballoon>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSmallballoon extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicSmallpopcorn1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallpopcorn>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSmallpopcorn extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicSmallworms1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallworms>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicSmallworms extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicCircus extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicCircus2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicCircus2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicCircus1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicCircus1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicMuseum extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallpopcorn1|ICharlesDickensStoryLayout_dicSmallchicken1|ICharlesDickensStoryLayout_dicSmallballoon1|ICharlesDickensStoryLayout_dicSmallworms1|ICharlesDickensStoryLayout_dicMuseum2>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicMuseum2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicMuseum1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicMuseum1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_slotButterfly extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicSmallchicken1|ICharlesDickensStoryLayout_dicSmallballoon1|ICharlesDickensStoryLayout_dicSmallworms1|ICharlesDickensStoryLayout_dicSmallpopcorn1|ICharlesDickensStoryLayout_dicButterflyBack|ICharlesDickensStoryLayout_dicButterfly3|ICharlesDickensStoryLayout_dicButterfly2|ICharlesDickensStoryLayout_dicButterfly1|ICharlesDickensStoryLayout_dicButterflyFront>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicButterflyBack extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicButterflyBack1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicButterflyBack1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicButterfly3 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicButterfly31>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicButterfly31 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicButterfly2 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicButterfly21>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicButterfly21 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicButterfly1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicButterfly11>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicButterfly11 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicButterflyFront extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicButterflyFront1>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicButterflyFront1 extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBHome1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBHome>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBHome extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBCircus1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBCircus>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBCircus extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBMuseum1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBMuseum>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBMuseum extends ICharlesDickensStoryLayoutSprite {
}
interface ICharlesDickensStoryLayout_dicBButterfly1 extends ICharlesDickensStoryLayoutContainer {
	readonly items: ICharlesDickensStoryLayoutArray<ICharlesDickensStoryLayout_dicBButterfly>;
	animation: string;
	isButton: boolean;
	option: string;
}
interface ICharlesDickensStoryLayout_dicBButterfly extends ICharlesDickensStoryLayoutSprite {
}
